import dayjs from 'dayjs';
import dayjsRelativeTimePlugin from 'dayjs/plugin/relativeTime';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React, { useMemo, useRef, useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button, FlexBox, Box, ButtonNew, MessageGlobalStyle, TooltipGlobalStyle, wsLayoutOmitPropKeys, message, Menu, colors, Modal as Modal$1, Card, Dropdown, Tooltip, Drawer, WsLayout } from '@helloworld1812/ws-components';
import styled, { css, keyframes, ThemeProvider, StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import antd4_EN_US from 'antd/es/locale/en_US';
import { ConfigProvider, Modal, Input as Input$1, Spin, Button as Button$1 } from 'antd';
import { theme, NormalizeGlobalStyle, FontGlobalStyle } from '@helloworld1812/ws-theme';
import '@helloworld1812/ws-ctx';
import { useLocation } from 'react-router-dom';
import { isFullScreenRoute, service, getNavigateFn, USER_PERMISSIONS, useBrands, useSegmentAnalytics, useAvailablePermissions, parseAvailablePermissions, hasUserPermissionV2 } from '@helloworld1812/ws-biz-hooks';
import qs from 'qs';
import { show, shutdown, Intercom } from '@intercom/messenger-js-sdk';
import { useUpdate, useMemoizedFn, useSessionStorageState } from 'ahooks';
import * as tmp from 'react-router';
import { useFeatureIsOn, useWsGrowthbook } from '@helloworld1812/ws-growthbook';
import { useSearchQuery, usePreviousUrl } from '@helloworld1812/ws-hooks';
import { useUsersMeCached, useHrQuery, useHrMutation, hrAxios } from '@helloworld1812/hr-api';
import { compact, identity, unionBy } from 'lodash';
import { IconCheckmark, IconShop, ChevronDown, IconCrown, IconHome, IconEnvelope, IconCalendarNew, IconAnalysis, IconUserEntity, IconSpeaker, IconDocumentAdd, IconSourcingTools, IconUserCheck, IconUsers, IconCopy, IconDocumentApprove, IconDollarCircle, IconExternalLink, IconClock, IconUser, IconLocationPin, IconTaxEntity, IconDepartmentsNew, IconBag, IconPuzzle, IconBrush, IconDocumentExport, IconAiStar, OutlinedBookOpen, IconBell, IconPositionNew2, IconPlusSync, IconClipboard, IconReapply, IconHealth, IconProfile, IconLock, Notifications } from '@helloworld1812/ws-icons';
import { globalConfig } from 'antd/es/config-provider';
import { SearchOutlined } from '@ant-design/icons';
import { wsLocalStorage } from '@helloworld1812/ws-storage';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var fails$n = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$m = fails$n;

var functionBindNative = !fails$m(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$g = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$3 && FunctionPrototype$2.bind.bind(call$g, call$g);

var functionUncurryThis = NATIVE_BIND$3 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$g.apply(fn, arguments);
  };
};

var uncurryThis$r = functionUncurryThis;

var toString$e = uncurryThis$r({}.toString);
var stringSlice$8 = uncurryThis$r(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$8(toString$e(it), 8, -1);
};

var uncurryThis$q = functionUncurryThis;
var fails$l = fails$n;
var classof$9 = classofRaw$2;

var $Object$4 = Object;
var split$1 = uncurryThis$q(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$l(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$9(it) === 'String' ? split$1(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$5 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$4 = isNullOrUndefined$5;

var $TypeError$e = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$9 = function (it) {
  if (isNullOrUndefined$4(it)) throw new $TypeError$e("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$8 = requireObjectCoercible$9;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$8(it));
};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$i =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var sharedStore = {exports: {}};

var isPure = false;

var global$h = global$i;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$h, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$h[key] = value;
  } return value;
};

var globalThis$1 = global$i;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$1[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.36.1',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var store$2 = sharedStore.exports;

var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$7 = requireObjectCoercible$9;

var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$6 = function (argument) {
  return $Object$3(requireObjectCoercible$7(argument));
};

var uncurryThis$p = functionUncurryThis;
var toObject$5 = toObject$6;

var hasOwnProperty = uncurryThis$p({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$5(it), key);
};

var uncurryThis$o = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$d = uncurryThis$o(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$d(++id + postfix, 36);
};

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$g = global$i;
var userAgent = engineUserAgent;

var process$1 = global$g.process;
var Deno = global$g.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = engineV8Version;
var fails$k = fails$n;
var global$f = global$i;

var $String$5 = global$f.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$k(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$e = global$i;
var shared$3 = shared$4;
var hasOwn$c = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var Symbol$1 = global$e.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$i = function (name) {
  if (!hasOwn$c(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$c(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$k = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$j = isCallable$k;

var isObject$d = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$j(it);
};

var isObject$c = isObject$d;

var $String$4 = String;
var $TypeError$d = TypeError;

// `Assert: Type(argument) is Object`
var anObject$c = function (argument) {
  if (isObject$c(argument)) return argument;
  throw new $TypeError$d($String$4(argument) + ' is not an object');
};

var objectDefineProperties = {};

var fails$j = fails$n;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$j(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var DESCRIPTORS$i = descriptors;
var fails$i = fails$n;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$i && fails$i(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var objectDefineProperty = {};

var global$d = global$i;
var isObject$b = isObject$d;

var document$1 = global$d.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$b(document$1) && isObject$b(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$h = descriptors;
var fails$h = fails$n;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$h && !fails$h(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var NATIVE_BIND$2 = functionBindNative;

var call$f = Function.prototype.call;

var functionCall = NATIVE_BIND$2 ? call$f.bind(call$f) : function () {
  return call$f.apply(call$f, arguments);
};

var global$c = global$i;
var isCallable$i = isCallable$k;

var aFunction = function (argument) {
  return isCallable$i(argument) ? argument : undefined;
};

var getBuiltIn$6 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$c[namespace]) : global$c[namespace] && global$c[namespace][method];
};

var uncurryThis$n = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$n({}.isPrototypeOf);

var getBuiltIn$5 = getBuiltIn$6;
var isCallable$h = isCallable$k;
var isPrototypeOf$4 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$5('Symbol');
  return isCallable$h($Symbol) && isPrototypeOf$4($Symbol.prototype, $Object$2(it));
};

var $String$3 = String;

var tryToString$2 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$g = isCallable$k;
var tryToString$1 = tryToString$2;

var $TypeError$c = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$5 = function (argument) {
  if (isCallable$g(argument)) return argument;
  throw new $TypeError$c(tryToString$1(argument) + ' is not a function');
};

var aCallable$4 = aCallable$5;
var isNullOrUndefined$3 = isNullOrUndefined$5;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$4 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$3(func) ? undefined : aCallable$4(func);
};

var call$e = functionCall;
var isCallable$f = isCallable$k;
var isObject$a = isObject$d;

var $TypeError$b = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$f(fn = input.toString) && !isObject$a(val = call$e(fn, input))) return val;
  if (isCallable$f(fn = input.valueOf) && !isObject$a(val = call$e(fn, input))) return val;
  if (pref !== 'string' && isCallable$f(fn = input.toString) && !isObject$a(val = call$e(fn, input))) return val;
  throw new $TypeError$b("Can't convert object to primitive value");
};

var call$d = functionCall;
var isObject$9 = isObject$d;
var isSymbol$1 = isSymbol$2;
var getMethod$3 = getMethod$4;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$h = wellKnownSymbol$i;

var $TypeError$a = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$h('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$9(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$3(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$d(exoticToPrim, input, pref);
    if (!isObject$9(result) || isSymbol$1(result)) return result;
    throw new $TypeError$a("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var DESCRIPTORS$g = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$b = anObject$c;
var toPropertyKey$1 = toPropertyKey$2;

var $TypeError$9 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$g ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPropertyKey$1(P);
  anObject$b(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPropertyKey$1(P);
  anObject$b(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$9('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var ceil = Math.ceil;
var floor$2 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$2 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$4 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;

var max$1 = Math.max;
var min$4 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$3(index);
  return integer < 0 ? max$1(integer + length, 0) : min$4(integer, length);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;

var min$3 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$4 = function (argument) {
  var len = toIntegerOrInfinity$2(argument);
  return len > 0 ? min$3(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$3 = toLength$4;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$4 = function (obj) {
  return toLength$3(obj.length);
};

var toIndexedObject$4 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$3 = lengthOfArrayLike$4;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$4($this);
    var length = lengthOfArrayLike$3(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var hiddenKeys$4 = {};

var uncurryThis$m = functionUncurryThis;
var hasOwn$b = hasOwnProperty_1;
var toIndexedObject$3 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;

var push$3 = uncurryThis$m([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$3(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$b(hiddenKeys$3, key) && hasOwn$b(O, key) && push$3(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$b(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$3(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$f = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$3 = objectDefineProperty;
var anObject$a = anObject$c;
var toIndexedObject$2 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$f && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$a(O);
  var props = toIndexedObject$2(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$3.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$6;

var html$1 = getBuiltIn$4('document', 'documentElement');

var shared$2 = shared$4;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */
var anObject$9 = anObject$c;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$9(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$g = wellKnownSymbol$i;
var create$4 = objectCreate;
var defineProperty$6 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$g('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$6(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$4(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var global$b = global$i;
var isCallable$e = isCallable$k;

var WeakMap$1 = global$b.WeakMap;

var weakMapBasicDetection = isCallable$e(WeakMap$1) && /native code/.test(String(WeakMap$1));

var createPropertyDescriptor$5 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$e = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;

var createNonEnumerableProperty$9 = DESCRIPTORS$e ? function (object, key, value) {
  return definePropertyModule$2.f(object, key, createPropertyDescriptor$4(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$a = global$i;
var isObject$8 = isObject$d;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$9;
var hasOwn$a = hasOwnProperty_1;
var shared$1 = sharedStore.exports;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$a.TypeError;
var WeakMap = global$a.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$8(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store$1 = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store$1.get = store$1.get;
  store$1.has = store$1.has;
  store$1.set = store$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store$1.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$1.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store$1.get(it) || {};
  };
  has = function (it) {
    return store$1.has(it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$a(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$8(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$a(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$a(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$5 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$5(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var DESCRIPTORS$d = descriptors;
var call$c = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;
var toIndexedObject$1 = toIndexedObject$5;
var toPropertyKey = toPropertyKey$2;
var hasOwn$9 = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$d ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$9(O, P)) return createPropertyDescriptor$3(!call$c(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$c = descriptors;
var hasOwn$8 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$c && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$8(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$c || (DESCRIPTORS$c && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$l = functionUncurryThis;
var isCallable$d = isCallable$k;
var store = sharedStore.exports;

var functionToString = uncurryThis$l(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$d(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$2 = store.inspectSource;

var uncurryThis$k = functionUncurryThis;
var fails$g = fails$n;
var isCallable$c = isCallable$k;
var hasOwn$7 = hasOwnProperty_1;
var DESCRIPTORS$b = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$1 = inspectSource$2;
var InternalStateModule$2 = internalState;

var enforceInternalState$1 = InternalStateModule$2.enforce;
var getInternalState$3 = InternalStateModule$2.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice$7 = uncurryThis$k(''.slice);
var replace$5 = uncurryThis$k(''.replace);
var join$1 = uncurryThis$k([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$b && !fails$g(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$7($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$5($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$7(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$b) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$7(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$7(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$b) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState$1(value);
  if (!hasOwn$7(state, 'source')) {
    state.source = join$1(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$c(this) && getInternalState$3(this).source || inspectSource$1(this);
}, 'toString');

var isCallable$b = isCallable$k;
var definePropertyModule$1 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$a = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$b(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$1.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$3 = getBuiltIn$6;
var uncurryThis$j = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$8 = anObject$c;

var concat$2 = uncurryThis$j([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$3('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$8(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$6 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$6(target, key) && !(exceptions && hasOwn$6(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$f = fails$n;
var isCallable$a = isCallable$k;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$a(detection) ? fails$f(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$9 = global$i;
var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$9;
var defineBuiltIn$9 = defineBuiltIn$a;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$9;
  } else if (STATIC) {
    target = global$9[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global$9[TARGET] && global$9[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$4(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$7(sourceProperty, 'sham', true);
    }
    defineBuiltIn$9(target, key, sourceProperty, options);
  }
};

var fails$e = fails$n;

var correctPrototypeGetter = !fails$e(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$5 = hasOwnProperty_1;
var isCallable$9 = isCallable$k;
var toObject$4 = toObject$6;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$4(O);
  if (hasOwn$5(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$9(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$d = fails$n;
var isCallable$8 = isCallable$k;
var isObject$7 = isObject$d;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$8 = defineBuiltIn$a;
var wellKnownSymbol$f = wellKnownSymbol$i;

var ITERATOR$5 = wellKnownSymbol$f('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$7(IteratorPrototype$2) || fails$d(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$8(IteratorPrototype$2[ITERATOR$5])) {
  defineBuiltIn$8(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$4 = objectDefineProperty.f;
var hasOwn$4 = hasOwnProperty_1;
var wellKnownSymbol$e = wellKnownSymbol$i;

var TO_STRING_TAG$2 = wellKnownSymbol$e('toStringTag');

var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$4(target, TO_STRING_TAG$2)) {
    defineProperty$4(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$3 = objectCreate;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;
var setToStringTag$3 = setToStringTag$4;
var Iterators$3 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$3(IteratorPrototype$1, { next: createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next) });
  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$3[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$i = functionUncurryThis;
var aCallable$3 = aCallable$5;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$i(aCallable$3(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$6 = isObject$d;

var isPossiblePrototype$1 = function (argument) {
  return isObject$6(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$1 = String;
var $TypeError$8 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$8("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject$5 = isObject$d;
var requireObjectCoercible$6 = requireObjectCoercible$9;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$6(O);
    aPossiblePrototype(proto);
    if (!isObject$5(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$b = _export;
var call$b = functionCall;
var FunctionName = functionName;
var isCallable$7 = isCallable$k;
var createIteratorConstructor$1 = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$4;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$9;
var defineBuiltIn$7 = defineBuiltIn$a;
var wellKnownSymbol$d = wellKnownSymbol$i;
var Iterators$2 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$d('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$2) {
          setPrototypeOf$2(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$7(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn$7(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$6(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$b(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$7(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$b({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn$7(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$2[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$2 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators$1 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$3 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$2;
var DESCRIPTORS$a = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$2 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject$1(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$1(index, false);
    case 'values': return createIterResultObject$1(target[index], false);
  } return createIterResultObject$1([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$1.Arguments = Iterators$1.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$a && values.name !== 'values') try {
  defineProperty$3(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var DESCRIPTORS$9 = descriptors;
var uncurryThis$h = functionUncurryThis;
var call$a = functionCall;
var fails$c = fails$n;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$3 = toObject$6;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$2 = Object.defineProperty;
var concat$1 = uncurryThis$h([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$c(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$9 && $assign({ b: 1 }, $assign(defineProperty$2({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$2(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$3(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$9 || call$a(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$a = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$a({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$8 = global$i;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$9;
var setToStringTag$1 = setToStringTag$4;
var wellKnownSymbol$c = wellKnownSymbol$i;

var ITERATOR$3 = wellKnownSymbol$c('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty$5(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    setToStringTag$1(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$5(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$8[COLLECTION_NAME] && global$8[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var errorImage = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%22113px%22%20height%3D%22164px%22%20viewBox%3D%220%200%20113%20164%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3Eghost%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M84.5165882%2C10.3461071%20C100.09547%2C21.8146249%20103.5%2C30%20105.516588%2C41.8461071%20C106.86098%2C49.7435119%20106.86098%2C73.7435119%20105.516588%2C113.846107%20L95.5%2C102.5%20L85%2C114.5%20L75%2C102.5%20L64%2C114.5%20L54%2C102.5%20L43.5%2C114.672187%20L33.5%2C102.5%20L23%2C114.672187%20L13.5%2C102.5%20L1.01658823%2C114.672187%20C-0.305686288%2C75.0188717%20-0.305686288%2C50.7435119%201.01658823%2C41.8461071%20C3%2C28.5%207.39649968%2C22.7471669%2022.5%2C11%20C45%2C-6.5%2072.5%2C1.5%2084.5165882%2C10.3461071%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Test%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22404%22%20transform%3D%22translate%28-409.000000%2C%20-275.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-3%22%20transform%3D%22translate%28412.000000%2C%20278.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-2%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22ghost%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cellipse%20id%3D%22Oval-5%22%20fill%3D%22%23EFF1EF%22%20cx%3D%2254%22%20cy%3D%22156%22%20rx%3D%2252%22%20ry%3D%225%22%3E%3C%2Fellipse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16.5%2C123.5%20C20%2C135%2096.5450773%2C127.950773%2097%2C132.5%20C97.5%2C137.5%2010.5%2C138.5%2011.5%2C144.5%20C12.2798379%2C149.179027%2026.2798379%2C151.512361%2053.5%2C151.5%22%20id%3D%22Line-2%22%20stroke%3D%22%23D1D1D1%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22square%22%20stroke-dasharray%3D%221%2C6%2C1%2C1%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Star%22%20stroke%3D%22%23979797%22%20stroke-width%3D%222%22%20fill%3D%22%23F5F6FA%22%20transform%3D%22translate%2870.159180%2C%20144.883476%29%20rotate%28-46.000000%29%20translate%28-70.159180%2C%20-144.883476%29%20%22%20points%3D%2270.1591796%20149.215728%2064.0324506%20151.010205%2065.826928%20144.883476%2064.0324506%20138.756747%2070.1591796%20140.551224%2076.2859086%20138.756747%2074.4914312%20144.883476%2076.2859086%20151.010205%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-3%22%20stroke%3D%22%23979797%22%20stroke-width%3D%222%22%20fill%3D%22%23F5F6FA%22%20cx%3D%2244.5%22%20cy%3D%22138.5%22%20r%3D%224.5%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-2%22%20stroke%3D%22%23979797%22%20fill%3D%22%23F5F6FA%22%20cx%3D%2227%22%20cy%3D%22122%22%20r%3D%222%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-2%22%20stroke%3D%22%23979797%22%20fill%3D%22%23F5F6FA%22%20cx%3D%2288.5%22%20cy%3D%22141.5%22%20r%3D%221.5%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M73.368724%2C122.457376%20L71.9185078%2C120.58816%20L70.4316699%2C122.457376%20C70.216822%2C122.718596%2070.0349364%2C122.904874%2069.8860077%2C123.016214%20C69.7370791%2C123.127554%2069.5478692%2C123.183223%2069.3183726%2C123.183223%20C69.0644614%2C123.183223%2068.848396%2C123.113636%2068.6701699%2C122.974462%20C68.4919438%2C122.835287%2068.402832%2C122.675773%2068.402832%2C122.495916%20C68.402832%2C122.311777%2068.5395514%2C122.04842%2068.8129942%2C121.705835%20L70.6221023%2C119.431943%20L69.0180753%2C117.537033%20C68.7397496%2C117.224425%2068.6005888%2C116.952503%2068.6005888%2C116.721259%20C68.6005888%2C116.541402%2068.683597%2C116.3851%2068.8496158%2C116.252349%20C69.0156347%2C116.119597%2069.2329208%2C116.053223%2069.5014807%2C116.053223%20C69.7358602%2C116.053223%2069.9299529%2C116.111033%2070.0837645%2C116.226655%20C70.2375761%2C116.342277%2070.4170202%2C116.524272%2070.6221023%2C116.772646%20L71.9185078%2C118.327115%20L73.1782916%2C116.772646%20C73.3882566%2C116.515708%2073.5701421%2C116.331572%2073.7239537%2C116.220232%20C73.8777653%2C116.108892%2074.0694165%2C116.053223%2074.2989132%2C116.053223%20C74.5625902%2C116.053223%2074.781097%2C116.118527%2074.9544402%2C116.249137%20C75.1277834%2C116.379747%2075.2144537%2C116.53712%2075.2144537%2C116.721259%20C75.2144537%2C116.85401%2075.1790532%2C116.981407%2075.108251%2C117.103452%20C75.0374489%2C117.225498%2074.9288058%2C117.370024%2074.7823186%2C117.537033%20L73.1782916%2C119.431943%20L74.9873997%2C121.705835%20C75.2706083%2C122.061267%2075.4122105%2C122.328907%2075.4122105%2C122.508763%20C75.4122105%2C122.692902%2075.3243195%2C122.851345%2075.1485348%2C122.984097%20C74.9727502%2C123.116848%2074.755464%2C123.183223%2074.49667%2C123.183223%20C74.2671733%2C123.183223%2074.0730807%2C123.125413%2073.9143862%2C123.00979%20C73.7556917%2C122.894168%2073.5738061%2C122.710032%2073.368724%2C122.457376%20Z%22%20id%3D%22x%22%20fill%3D%22%23949596%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Rectangle-3%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill%3D%22%23F5F6FA%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20stroke%3D%22%23949596%22%20stroke-width%3D%223%22%20d%3D%22M95.5050133%2C104.772159%20L84.9721765%2C116.809687%20L74.9462066%2C104.778523%20L63.9462066%2C116.778523%20L53.9802406%2C104.819364%20L43.4720103%2C117.001091%20L33.4720103%2C104.828905%20L22.9420079%2C117.035872%20L13.3480088%2C104.743246%20L-0.36932221%2C118.118588%20L-0.482578507%2C114.722178%20C-1.80854101%2C74.9582647%20-1.80854101%2C50.6518695%20-0.46711672%2C41.6256085%20C1.53739923%2C28.1374943%205.83268151%2C22.0631776%2021.5790891%2C9.81597167%20C32.2223154%2C1.53790675%2044.659302%2C-1.76058178%2057.5622574%2C-0.701711081%20C68.1120865%2C0.164052194%2078.4414708%2C4.0112448%2085.4058511%2C9.13812881%20C99.8098519%2C19.7417487%20104.60182%2C27.5341979%20106.995315%2C41.5943802%20C108.364666%2C49.6384015%20108.364666%2C73.6587002%20107.015746%2C113.896365%20L106.889322%2C117.667527%20L95.5050133%2C104.772159%20Z%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M51%2C-5.42101086e-17%20C51.4480077%2C0.00153007755%2051.781341%2C0.00153007755%2052%2C-2.31065167e-15%20C81.0179062%2C-0.203054278%2099.5101585%2C14.3033779%20105.5%2C37.5140137%20C105.996993%2C39.4398598%20106.330326%2C41.2731931%20106.5%2C43.0140137%20L106.5%2C115.5%20L96%2C102.5%20C97.3333333%2C68.5%2096.5%2C47.3333333%2093.5%2C39%20C86.9215687%2C20.7265796%2072.754902%2C7.72657959%2051%2C-5.42101086e-17%20Z%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.539175725%22%20mask%3D%22url%28%23mask-2%29%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle-2%22%20fill%3D%22%23949596%22%20x%3D%2247%22%20y%3D%2283%22%20width%3D%2215%22%20height%3D%223%22%20rx%3D%221.5%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%23949596%22%20cx%3D%2281%22%20cy%3D%2256%22%20r%3D%223%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%23949596%22%20cx%3D%2228%22%20cy%3D%2256%22%20r%3D%223%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

const ChunkLoadErrorFallback$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "catch-all-error-boundarystyle__ChunkLoadErrorFallback",
  componentId: "sc-1fb604f-0"
})(["width:100%;height:100%;", " display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:#f5f6fa;& .error-container{width:30rem;max-width:100%;height:20rem;max-height:100%;padding:1rem;& .left{display:flex;}& .right{display:flex;flex-direction:column;& .title{font-size:2rem;}& .content{font-size:1rem;}& .row:not(:first-child){margin-top:1rem;}}}"], ({
  fullScreen
}) => fullScreen && css(["position:fixed;top:0;left:0;z-index:9999;"]));
const GeneralErrorFallback$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "catch-all-error-boundarystyle__GeneralErrorFallback",
  componentId: "sc-1fb604f-1"
})(["width:100%;height:100%;", " display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:#f5f6fa;& .error-container{width:30rem;height:20rem;padding:1rem;display:flex;justify-content:center;align-items:center;& .left{display:flex;}& .right{margin-left:4rem;display:flex;flex-direction:column;& .title{font-size:2rem;}& .content{font-size:1rem;}& .row:not(:first-child){margin-top:1rem;}}}"], ({
  fullScreen
}) => fullScreen && css(["position:fixed;top:0;left:0;z-index:9999;"]));
const CatchAllErrorBoundaryS = {
  GeneralErrorFallback: GeneralErrorFallback$1,
  ChunkLoadErrorFallback: ChunkLoadErrorFallback$1
};

function ChunkLoadErrorFallback(props) {
  const {
    t
  } = useTranslation('app-global-components');
  return jsx(CatchAllErrorBoundaryS.ChunkLoadErrorFallback, Object.assign({}, props, {
    children: jsxs("div", {
      className: "error-container",
      children: [jsx("div", {
        className: "left",
        children: jsx("img", {
          src: errorImage,
          alt: t('error')
        })
      }), jsxs("div", {
        className: "right",
        children: [jsx("div", {
          className: "row title",
          children: jsx(Typography, {
            variant: "h1",
            color: "textSecondary",
            fontSize: 55,
            fontWeight: "semibold",
            children: t('Oops!')
          })
        }), jsx("div", {
          className: "row content",
          children: jsx(Typography, {
            variant: "body",
            color: "textSecondary",
            fontSize: 13,
            children: t('A new version of our app is available, please refresh your browser.')
          })
        }), jsx("div", {
          className: "row action",
          children: jsx(Button, {
            type: "primary",
            size: "compact",
            onClick: () => window.location.reload(),
            children: t('Refresh')
          })
        })]
      })]
    })
  }));
}

function GeneralErrorFallback(props) {
  const {
    t
  } = useTranslation('app-global-components');
  return jsx(CatchAllErrorBoundaryS.GeneralErrorFallback, Object.assign({}, props, {
    children: jsxs(FlexBox, {
      flexDirection: {
        phone: 'column',
        tablet: 'row'
      },
      gap: 40,
      className: "error-container",
      children: [jsx("div", {
        className: "left",
        children: jsx("img", {
          src: errorImage,
          alt: t('error')
        })
      }), jsxs("div", {
        className: "right",
        children: [jsx("div", {
          className: "row title",
          children: jsx(Typography, {
            variant: "h3",
            color: "textSecondary",
            fontSize: 20,
            fontWeight: "semibold",
            children: t('Oops!')
          })
        }), jsx("div", {
          className: "row content",
          children: jsx(Typography, {
            variant: "body",
            color: "textSecondary",
            fontSize: 13,
            children: t('Please check your browser console for error details.')
          })
        })]
      })]
    })
  }));
}

/**
 * CatchAllErrorBoundary
 */
class CatchAllErrorBoundary extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      hasError: false,
      error: undefined
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    if ((error === null || error === void 0 ? void 0 : error.name) === 'ChunkLoadError') {
      console.error('ChunkLoadError caught:', error, errorInfo);
    } else {
      console.error('Error caught:', error, errorInfo);
    }
  }
  render() {
    const _a = this.props,
      {
        children
      } = _a,
      restProps = __rest(_a, ["children"]);
    const {
      hasError,
      error
    } = this.state;
    if (!hasError) {
      return children;
    }
    if ((error === null || error === void 0 ? void 0 : error.name) === 'ChunkLoadError') {
      return jsx(ChunkLoadErrorFallback, Object.assign({}, restProps));
    }
    if (process.env.NODE_ENV === 'development') {
      return jsx(GeneralErrorFallback, Object.assign({}, restProps));
    }
    return children;
  }
}

var NotFoundSvg = "data:image/svg+xml,%3Csvg%20width%3D%22195%22%20height%3D%22153%22%20viewBox%3D%220%200%20195%20153%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cg%20style%3D%22mix-blend-mode%3Aluminosity%22%20opacity%3D%220.9%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M155.623%2041.9248C150.562%2041.7797%20145.566%2041.1656%20140.66%2039.8929C140.314%2039.8036%20139.986%2039.6584%20139.649%2039.544C137.797%2038.9244%20136.014%2038.8965%20134.148%2039.6891C129.011%2041.8718%20123.577%2042.8598%20118.053%2043.4711C114.076%2043.9121%20110.171%2043.605%20106.315%2042.564C105.102%2042.2374%20103.96%2041.7322%20102.803%2041.2661C102.351%2041.0847%20101.939%2041.0735%20101.47%2041.1712C99.2496%2041.629%2097.0603%2042.2597%2094.7895%2042.4579C90.6297%2042.8235%2086.5288%2042.7454%2082.7255%2040.6884C80.9347%2039.7198%2079.9832%2038.2406%2079.9776%2036.1947C79.9747%2035.109%2080.5081%2034.2688%2081.1929%2033.4818C82.8771%2031.5475%2084.9485%2030.1604%2087.2642%2029.0886C90.8795%2027.4167%2094.6492%2026.4398%2098.6546%2026.5543C99.8503%2026.5878%20101.06%2026.6603%20102.225%2026.8976C103.207%2027.0985%20103.926%2026.7915%20104.586%2026.1831C108.807%2022.2839%20113.932%2020.1041%20119.35%2018.4629C123.184%2017.3018%20127.072%2016.992%20130.979%2017.8851C133.811%2018.5327%20136.447%2019.6994%20138.611%2021.7173C139.877%2022.9007%20139.865%2022.9259%20141.375%2022.0913C145.047%2020.065%20148.948%2018.6611%20153.108%2018.0945C158.076%2017.4135%20162.932%2017.8517%20167.303%2020.506C171.005%2022.7556%20173.483%2025.9681%20173.803%2030.4339C174.034%2033.6464%20172.655%2036.1724%20170.067%2038.0843C167.289%2040.1413%20164.128%2041.1908%20160.732%2041.5955C159.039%2041.7992%20157.335%2041.9555%20155.62%2041.922L155.623%2041.9248Z%22%20%20%20%20%20%20fill%3D%22%23E4E4E7%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M83.8201%2066.118C80.7634%2066.1934%2077.9144%2065.7775%2075.0766%2065.2751C74.1447%2065.1104%2073.2774%2065.1802%2072.382%2065.4844C69.126%2066.5953%2065.783%2067.1312%2062.3306%2067.2261C58.6984%2067.3266%2055.1702%2066.8074%2051.6616%2066.0008C51.4146%2065.945%2051.1367%2065.9143%2050.9318%2065.7831C49.621%2064.9374%2048.2456%2065.1746%2046.8169%2065.3812C43.6226%2065.8417%2040.4144%2065.7887%2037.2117%2065.37C36.1002%2065.2249%2035.1009%2064.7643%2034.1522%2064.2312C32.6056%2063.3604%2032.1284%2061.6439%2032.9368%2060.0111C33.7228%2058.4174%2034.9859%2057.2591%2036.4482%2056.2766C39.9597%2053.9154%2043.8191%2052.7515%2048.0575%2052.8938C49.1466%2052.9301%2050.2581%2052.958%2051.3023%2053.3432C51.7935%2053.5246%2052.1472%2053.3097%2052.4924%2053.0418C54.2074%2051.7188%2055.9449%2050.4209%2057.9406%2049.5445C60.1636%2048.5704%2062.4428%2047.708%2064.9185%2047.7164C67.5233%2047.7247%2069.9541%2048.4253%2072.1827%2049.7818C72.8788%2050.206%2073.5806%2050.6191%2074.2626%2051.0629C74.664%2051.3252%2075.0373%2051.3392%2075.4864%2051.1745C77.7797%2050.34%2080.1515%2049.9492%2082.5907%2049.8097C85.987%2049.6115%2089.257%2050.2088%2092.4204%2051.3197C94.7136%2052.1235%2096.6476%2053.5274%2097.6131%2055.8552C98.2194%2057.3177%2098.0987%2058.864%2097.3324%2060.2679C95.8448%2063.0004%2093.4309%2064.5439%2090.4724%2065.3337C88.2409%2065.931%2085.9702%2066.2018%2083.8201%2066.118Z%22%20%20%20%20%20%20fill%3D%22%23E4E4E7%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M128.427%2079.3704C126.617%2079.2839%20124.82%2079.0885%20123.038%2078.7704C122.521%2078.6783%20122.041%2078.6922%20121.539%2078.8653C117.082%2080.392%20112.54%2080.4394%20108.06%2079.1611C106.497%2078.7145%20105.082%2078.8764%20103.583%2078.9825C101.492%2079.1276%2099.3982%2079.1862%2097.3969%2078.4047C95.7128%2077.746%2095.2862%2076.4705%2096.2461%2074.9326C97.324%2073.2049%2099.0334%2072.2699%20100.863%2071.5861C103.12%2070.7404%20105.453%2070.4417%20107.836%2071.0586C108.274%2071.1702%20108.566%2070.9302%20108.86%2070.6818C110.275%2069.4816%20111.883%2068.622%20113.629%2068.0023C116.661%2066.9278%20119.462%2067.4832%20122.053%2069.2639C122.69%2069.7021%20123.243%2069.7384%20123.967%2069.5039C127.52%2068.354%20131.057%2068.5606%20134.54%2069.8333C135.587%2070.2157%20136.458%2070.8883%20137.148%2071.7675C138.29%2073.2217%20138.097%2075.1057%20136.744%2076.624C135.194%2078.3657%20133.126%2078.9127%20130.945%2079.2058C130.114%2079.3174%20129.269%2079.3174%20128.427%2079.3704Z%22%20%20%20%20%20%20fill%3D%22%23E4E4E7%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M141.779%208.25195L143.413%2011.5667L147.075%2012.0864L144.427%2014.6708L145.047%2018.2946L141.779%2016.581L138.511%2018.2946L139.131%2014.6708L136.482%2012.0864L140.145%2011.5667L141.779%208.25195Z%22%20%20%20%20%20%20fill%3D%22%23D4D4D8%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M33.0123%20102.738L34.6464%20106.053L38.3088%20106.572L35.6605%20109.157L36.2803%20112.78L33.0123%20111.067L29.7443%20112.78L30.3641%20109.157L27.7158%20106.572L31.3782%20106.053L33.0123%20102.738Z%22%20%20%20%20%20%20fill%3D%22%23D4D4D8%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M117.234%2048.2183L118.868%2051.533L122.53%2052.0527L119.882%2054.6371L120.502%2058.2609L117.234%2056.5473L113.966%2058.2609L114.586%2054.6371L111.938%2052.0527L115.6%2051.533L117.234%2048.2183Z%22%20%20%20%20%20%20fill%3D%22%23D4D4D8%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M150.193%2070.9092L152.815%2076.2092L158.666%2077.0527L154.437%2081.1717L155.424%2086.9778L150.193%2084.2364L144.962%2086.9778L145.949%2081.1717L141.719%2077.0527L147.571%2076.2092L150.193%2070.9092Z%22%20%20%20%20%20%20fill%3D%22%23D4D4D8%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M81.9584%2083.6729L84.0729%2087.9741L88.8377%2088.6628L85.398%2092.0082L86.2016%2096.7312L81.9584%2094.5103L77.7011%2096.7312L78.5047%2092.0082L75.0649%2088.6628L79.8297%2087.9741L81.9584%2083.6729Z%22%20%20%20%20%20%20fill%3D%22%23D4D4D8%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M51.34%2026.0059L53.4126%2030.1954L58.0514%2030.8702L54.6957%2034.1319L55.4852%2038.7291L51.34%2036.564L47.1949%2038.7291L47.9844%2034.1319L44.6287%2030.8702L49.2675%2030.1954L51.34%2026.0059Z%22%20%20%20%20%20%20fill%3D%22%23D4D4D8%22%20%2F%3E%20%20%20%20%3Cpath%20d%3D%22M104.065%2096.7619L94.0027%20102.67L103.346%20117.703L113.408%20111.795L104.065%2096.7619Z%22%20fill%3D%22%23A0A2B2%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M110.409%2085.5148C113.477%2073.6298%20106.241%2061.5303%2094.2455%2058.49C82.2504%2055.4496%2070.0389%2062.6196%2066.9704%2074.5046C63.9018%2086.3897%2071.1383%2098.4891%2083.1334%20101.529C95.1285%20104.57%20107.34%2097.3998%20110.409%2085.5148Z%22%20%20%20%20%20%20fill%3D%22white%22%20fill-opacity%3D%220.25%22%20%2F%3E%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20%20%20%20%20%20d%3D%22M95.9292%2051.9648C111.562%2055.9271%20120.992%2071.6955%20116.993%2087.1844C112.994%20102.673%2097.08%20112.018%2081.4475%20108.055C65.8151%20104.093%2056.3843%2088.3246%2060.3834%2072.8356C64.3824%2057.3467%2080.2968%2048.0025%2095.9292%2051.9648ZM94.2453%2058.4898C106.24%2061.5302%20113.477%2073.6296%20110.408%2085.5147C107.34%2097.3997%2095.1283%20104.57%2083.1332%20101.529C71.138%2098.489%2063.9016%2086.3895%2066.9701%2074.5045C70.0387%2062.6195%2082.2502%2055.4495%2094.2453%2058.4898Z%22%20%20%20%20%20%20fill%3D%22%23A0A2B2%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M125.662%20143.068C122.823%20144.804%20118.957%20143.673%20117.027%20140.541L101.711%20115.01L111.692%20108.903L119.499%20121.577L127.307%20134.251C129.238%20137.383%20128.501%20141.329%20125.662%20143.068Z%22%20%20%20%20%20%20fill%3D%22%2368728A%22%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

const NotFoundPage = () => {
  const {
    t
  } = useTranslation('app-global-components');
  return jsxs(FlexBox, {
    bgColor: "surfaceBackground",
    column: true,
    gap: "4px",
    justifyContent: "center",
    alignItems: "center",
    paddingX: "20px",
    paddingY: "40px",
    width: "100%",
    height: "100%",
    children: [jsx(Box, {
      mb: "20px",
      children: jsx("img", {
        src: NotFoundSvg,
        alt: t('Not found')
      })
    }), jsx(Typography, {
      variant: "body",
      color: "#272727",
      fontWeight: "semibold",
      children: t('We can’t find what you’re looking for.')
    }), jsx(Typography, {
      variant: "body",
      color: "textPrimary",
      children: t('Try reloading this page or go to the previous page.')
    }), jsx(ButtonNew, {
      type: "primary",
      mt: "16px",
      style: {
        width: 'fit-content'
      },
      onClick: () => {
        window.location.reload();
      },
      children: t('Reload page')
    })]
  });
};

function ErrorPage({
  className = ''
}) {
  const {
    t
  } = useTranslation('app-global-components');
  return jsxs(FlexBox, {
    className: className,
    align: "center",
    justify: "center",
    width: "100%",
    height: "100%",
    children: [jsx("img", {
      src: errorImage,
      alt: t('Error')
    }), jsxs(FlexBox, {
      ml: 4,
      column: true,
      children: [jsx(Typography, {
        color: "#9e9fa0",
        fontSize: "55px",
        fontWeight: "semibold",
        mb: "0.2em",
        children: t('Oops!')
      }), jsxs(Typography, {
        fontSize: "13px",
        color: "#9e9fa0",
        children: [t("It looks like you found our error page instead. That's probably not where you wanted to go."), jsx("br", {}), t('Please try again, go back to home, or reach out to us if you have questions!')]
      }), jsx(Box, {
        mt: 2,
        mb: 2,
        children: jsx(ButtonNew, {
          type: "primary",
          onClick: () => window.location.href = '/',
          children: t('Go to homepage')
        })
      })]
    })]
  });
}

const Loader$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "loaderstyles__Loader",
  componentId: "sc-iwgigh-0"
})(({
  fullScreen,
  theme
}) => css(["display:block;background-color:#fff;width:100%;position:absolute;top:0;bottom:0;left:0;right:0;z-index:", ";display:flex;justify-content:center;align-items:center;opacity:1;text-align:center;", ""], theme.zIndex.appBar - 2, fullScreen && 'position: fixed;'));
const spinnerKeyframes = /*#__PURE__*/keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
const Spinner = /*#__PURE__*/styled.div.withConfig({
  displayName: "loaderstyles__Spinner",
  componentId: "sc-iwgigh-1"
})(["width:48px;height:48px;margin:0 auto;text-indent:-12345px;border-top:1px solid rgba(0,0,0,0.08);border-right:1px solid rgba(0,0,0,0.08);border-bottom:1px solid rgba(0,0,0,0.08);border-left:1px solid rgba(0,0,0,0.7);border-radius:50%;z-index:", ";animation:", " 600ms infinite linear;"], ({
  theme
}) => theme.zIndex.drawer - 1, spinnerKeyframes);
const S$2 = {
  Loader: Loader$1,
  Spinner
};

function Loader({
  spinning,
  fullScreen,
  children
}) {
  const {
    t
  } = useTranslation('app-global-components');
  return jsxs(Fragment, {
    children: [children, spinning && jsx(S$2.Loader, {
      fullScreen: fullScreen,
      "data-testid": "loader-overlay",
      children: jsxs(FlexBox, {
        width: 100,
        height: 100,
        display: "inline-flex",
        column: true,
        justify: "space-around",
        children: [jsx(S$2.Spinner, {}), jsx(Typography, {
          variant: "caption",
          textAlign: "center",
          fontSize: 12,
          width: 100,
          letterSpacing: 4,
          color: "#000",
          children: t('LOADING')
        })]
      })
    })]
  });
}

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$2 = FunctionPrototype.apply;
var call$9 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$9.bind(apply$2) : function () {
  return call$9.apply(apply$2, arguments);
});

var defineProperty$1 = objectDefineProperty.f;

var proxyAccessor$2 = function (Target, Source, key) {
  key in Target || defineProperty$1(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var isCallable$6 = isCallable$k;
var isObject$4 = isObject$d;
var setPrototypeOf$1 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$2 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$1 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$6(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$4(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$1($this, NewTargetPrototype);
  return $this;
};

var wellKnownSymbol$b = wellKnownSymbol$i;

var TO_STRING_TAG$1 = wellKnownSymbol$b('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$5 = isCallable$k;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$a = wellKnownSymbol$i;

var TO_STRING_TAG = wellKnownSymbol$a('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$8 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$5(O.callee) ? 'Arguments' : result;
};

var classof$7 = classof$8;

var $String = String;

var toString$c = function (argument) {
  if (classof$7(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var toString$b = toString$c;

var normalizeStringArgument$1 = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$b(argument);
};

var isObject$3 = isObject$d;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$9;

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause$1 = function (O, options) {
  if (isObject$3(options) && 'cause' in options) {
    createNonEnumerableProperty$4(O, 'cause', options.cause);
  }
};

var uncurryThis$g = functionUncurryThis;

var $Error = Error;
var replace$4 = uncurryThis$g(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

var errorStackClear = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace$4(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};

var fails$b = fails$n;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;

var errorStackInstallable = !fails$b(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor$1(1, 7));
  return error.stack !== 7;
});

var createNonEnumerableProperty$3 = createNonEnumerableProperty$9;
var clearErrorStack = errorStackClear;
var ERROR_STACK_INSTALLABLE = errorStackInstallable;

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

var errorStackInstall = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty$3(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};

var getBuiltIn$2 = getBuiltIn$6;
var hasOwn$3 = hasOwnProperty_1;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$9;
var isPrototypeOf$3 = objectIsPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var copyConstructorProperties = copyConstructorProperties$2;
var proxyAccessor$1 = proxyAccessor$2;
var inheritIfRequired$1 = inheritIfRequired$2;
var normalizeStringArgument = normalizeStringArgument$1;
var installErrorCause = installErrorCause$1;
var installErrorStack = errorStackInstall;
var DESCRIPTORS$8 = descriptors;

var wrapErrorConstructorWithCause$1 = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn$2.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (hasOwn$3(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn$2('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty$2(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf$3(OriginalErrorPrototype, this)) inheritIfRequired$1(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS$8 && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor$1(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor$1(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty$2(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $$9 = _export;
var global$7 = global$i;
var apply$1 = functionApply;
var wrapErrorConstructorWithCause = wrapErrorConstructorWithCause$1;

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global$7[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED$1 = new Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED$1);
  $$9({ global: true, constructor: true, arity: 1, forced: FORCED$1 }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED$1);
    $$9({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED$1 }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply$1(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply$1(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply$1(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply$1(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply$1(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply$1(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply$1(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply$1(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply$1(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply$1(init, this, arguments); };
});

// This implements the default behavior from styled-components v5
const shouldForwardProp = (propName, target) => {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
};
function getSubAppContainer() {
  const subAppContainer = document.getElementById('subapp_container');
  if (subAppContainer == null) {
    throw new Error("Sub app container '#subapp_container' not found!");
  }
  return subAppContainer;
}
const WsThemeProvider = ({
  children,
  styleSheetManagerProps,
  antdConfig,
  isMfe: isMfeSubApp,
  publicPath,
  withFontGlobalStyle: _withFontGlobalStyle = true
}) => {
  ConfigProvider.config({
    prefixCls: 'ant4',
    iconPrefixCls: 'ant4icon'
  });
  return jsx(ThemeProvider, {
    theme: theme,
    children: jsx(StyleSheetManager, Object.assign({
      enableVendorPrefixes: true,
      shouldForwardProp: shouldForwardProp
    }, isMfeSubApp ? {
      target: getSubAppContainer()
    } : {}, styleSheetManagerProps, {
      children: jsxs(ConfigProvider, Object.assign({
        locale: antd4_EN_US,
        prefixCls: "ant4",
        iconPrefixCls: "ant4icon"
      }, isMfeSubApp ? {
        getPopupContainer: getSubAppContainer
      } : {}, antdConfig, {
        children: [children, !isMfeSubApp && jsxs(Fragment, {
          children: [jsx(NormalizeGlobalStyle, {}), jsx(MessageGlobalStyle, {}), jsx(TooltipGlobalStyle, {}), _withFontGlobalStyle && jsx(FontGlobalStyle, {
            publicPath: publicPath
          })]
        })]
      }))
    }))
  });
};

var $$8 = _export;
var $includes = arrayIncludes.includes;
var fails$a = fails$n;
var addToUnscopables$1 = addToUnscopables$3;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$a(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$8({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');

var isObject$2 = isObject$d;
var classof$6 = classofRaw$2;
var wellKnownSymbol$9 = wellKnownSymbol$i;

var MATCH$2 = wellKnownSymbol$9('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$2(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$6(it) === 'RegExp');
};

var isRegExp$1 = isRegexp;

var $TypeError$7 = TypeError;

var notARegexp = function (it) {
  if (isRegExp$1(it)) {
    throw new $TypeError$7("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$8 = wellKnownSymbol$i;

var MATCH$1 = wellKnownSymbol$8('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$7 = _export;
var uncurryThis$f = functionUncurryThis;
var notARegExp$2 = notARegexp;
var requireObjectCoercible$5 = requireObjectCoercible$9;
var toString$a = toString$c;
var correctIsRegExpLogic$2 = correctIsRegexpLogic;

var stringIndexOf$2 = uncurryThis$f(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$7({ target: 'String', proto: true, forced: !correctIsRegExpLogic$2('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$2(
      toString$a(requireObjectCoercible$5(this)),
      toString$a(notARegExp$2(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

function useIsFullScreenRoute() {
  const routerLocation = useLocation();
  return useMemo(() => isFullScreenRoute(routerLocation.pathname), [routerLocation.pathname]);
}

var classof$5 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$3 = Array.isArray || function isArray(argument) {
  return classof$5(argument) === 'Array';
};

var $TypeError$6 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$2 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$6('Maximum allowed index exceeded');
  return it;
};

var classofRaw = classofRaw$2;
var uncurryThis$e = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$e(fn);
};

var uncurryThis$d = functionUncurryThisClause;
var aCallable$2 = aCallable$5;
var NATIVE_BIND = functionBindNative;

var bind$2 = uncurryThis$d(uncurryThis$d.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$2(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$2(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var isArray$2 = isArray$3;
var lengthOfArrayLike$2 = lengthOfArrayLike$4;
var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$2;
var bind$1 = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind$1(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$2(element)) {
        elementLen = lengthOfArrayLike$2(element);
        targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger$1(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$1;

var uncurryThis$c = functionUncurryThis;
var fails$9 = fails$n;
var isCallable$4 = isCallable$k;
var classof$4 = classof$8;
var getBuiltIn$1 = getBuiltIn$6;
var inspectSource = inspectSource$2;

var noop = function () { /* empty */ };
var construct = getBuiltIn$1('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$2 = uncurryThis$c(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$4(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$4(argument)) return false;
  switch (classof$4(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$2(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$9(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isArray$1 = isArray$3;
var isConstructor = isConstructor$1;
var isObject$1 = isObject$d;
var wellKnownSymbol$7 = wellKnownSymbol$i;

var SPECIES$2 = wellKnownSymbol$7('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray$1(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray$1(C.prototype))) C = undefined;
    else if (isObject$1(C)) {
      C = C[SPECIES$2];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var $$6 = _export;
var flattenIntoArray = flattenIntoArray_1;
var aCallable$1 = aCallable$5;
var toObject$2 = toObject$6;
var lengthOfArrayLike$1 = lengthOfArrayLike$4;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$$6({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject$2(this);
    var sourceLen = lengthOfArrayLike$1(O);
    var A;
    aCallable$1(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

var DESCRIPTORS$7 = descriptors;
var isArray = isArray$3;

var $TypeError$5 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS$7 && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor$3(O, 'length').writable) {
    throw new $TypeError$5('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $$5 = _export;
var toObject$1 = toObject$6;
var lengthOfArrayLike = lengthOfArrayLike$4;
var setArrayLength = arraySetLength;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$2;
var fails$8 = fails$n;

var INCORRECT_TO_LENGTH = fails$8(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$$5({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject$1(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = addToUnscopables$3;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');

var anObject$7 = anObject$c;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$7(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$8 = functionCall;
var hasOwn$2 = hasOwnProperty_1;
var isPrototypeOf$2 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$4 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$4) && !hasOwn$2(R, 'flags') && isPrototypeOf$2(RegExpPrototype$4, R)
    ? call$8(regExpFlags, R) : flags;
};

var fails$7 = fails$n;
var global$6 = global$i;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$6.RegExp;

var UNSUPPORTED_Y$2 = fails$7(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY$1 = UNSUPPORTED_Y$2 || fails$7(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$7(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$1,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor$4 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

var getBuiltIn = getBuiltIn$6;
var defineBuiltInAccessor$3 = defineBuiltInAccessor$4;
var wellKnownSymbol$6 = wellKnownSymbol$i;
var DESCRIPTORS$6 = descriptors;

var SPECIES$1 = wellKnownSymbol$6('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$6 && Constructor && !Constructor[SPECIES$1]) {
    defineBuiltInAccessor$3(Constructor, SPECIES$1, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var fails$6 = fails$n;
var global$5 = global$i;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$5.RegExp;

var regexpUnsupportedDotAll = fails$6(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$5 = fails$n;
var global$4 = global$i;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$4.RegExp;

var regexpUnsupportedNcg = fails$5(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

var DESCRIPTORS$5 = descriptors;
var global$3 = global$i;
var uncurryThis$b = functionUncurryThis;
var isForced = isForced_1;
var inheritIfRequired = inheritIfRequired$2;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$9;
var create$2 = objectCreate;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var isRegExp = isRegexp;
var toString$9 = toString$c;
var getRegExpFlags$1 = regexpGetFlags;
var stickyHelpers$1 = regexpStickyHelpers;
var proxyAccessor = proxyAccessor$2;
var defineBuiltIn$6 = defineBuiltIn$a;
var fails$4 = fails$n;
var hasOwn$1 = hasOwnProperty_1;
var enforceInternalState = internalState.enforce;
var setSpecies = setSpecies$1;
var wellKnownSymbol$5 = wellKnownSymbol$i;
var UNSUPPORTED_DOT_ALL$2 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var MATCH = wellKnownSymbol$5('match');
var NativeRegExp = global$3.RegExp;
var RegExpPrototype$3 = NativeRegExp.prototype;
var SyntaxError = global$3.SyntaxError;
var exec$1 = uncurryThis$b(RegExpPrototype$3.exec);
var charAt$5 = uncurryThis$b(''.charAt);
var replace$3 = uncurryThis$b(''.replace);
var stringIndexOf$1 = uncurryThis$b(''.indexOf);
var stringSlice$6 = uncurryThis$b(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers$1.MISSED_STICKY;
var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS$5 &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL$2 || UNSUPPORTED_NCG$1 || fails$4(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt$5(string, index);
    if (chr === '\\') {
      result += chr + charAt$5(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = create$2(null);
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt$5(string, index);
    if (chr === '\\') {
      chr += charAt$5(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec$1(IS_NCG, stringSlice$6(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn$1(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf$1(RegExpPrototype$3, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf$1(RegExpPrototype$3, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags$1(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$9(pattern);
    flags = flags === undefined ? '' : toString$9(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL$2 && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$1(flags, 's') > -1;
      if (dotAll) flags = replace$3(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$1(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y$1) flags = replace$3(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG$1) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$3, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty$1(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype$3.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$3;
  defineBuiltIn$6(global$3, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var DESCRIPTORS$4 = descriptors;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var classof$3 = classofRaw$2;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$4;
var getInternalState$1 = internalState.get;

var RegExpPrototype$2 = RegExp.prototype;
var $TypeError$4 = TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS$4 && UNSUPPORTED_DOT_ALL$1) {
  defineBuiltInAccessor$2(RegExpPrototype$2, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype$2) return;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof$3(this) === 'RegExp') {
        return !!getInternalState$1(this).dotAll;
      }
      throw new $TypeError$4('Incompatible receiver, RegExp required');
    }
  });
}

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$7 = functionCall;
var uncurryThis$a = functionUncurryThis;
var toString$8 = toString$c;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4;
var create$1 = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$4 = uncurryThis$a(''.charAt);
var indexOf = uncurryThis$a(''.indexOf);
var replace$2 = uncurryThis$a(''.replace);
var stringSlice$5 = uncurryThis$a(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$7(nativeExec, re1, 'a');
  call$7(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$8(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$7(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$7(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$5(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$4(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$7(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$5(match.input, charsAdded);
        match[0] = stringSlice$5(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$7(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$1(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$4 = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$4({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var $$3 = _export;
var call$6 = functionCall;
var isCallable$3 = isCallable$k;
var anObject$6 = anObject$c;
var toString$7 = toString$c;

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$$3({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject$6(this);
    var string = toString$7(S);
    var exec = R.exec;
    if (!isCallable$3(exec)) return call$6(nativeTest, R, string);
    var result = call$6(exec, R, string);
    if (result === null) return false;
    anObject$6(result);
    return true;
  }
});

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn$5 = defineBuiltIn$a;
var anObject$5 = anObject$c;
var $toString$1 = toString$c;
var fails$3 = fails$n;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$3(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$5(RegExpPrototype$1, TO_STRING, function toString() {
    var R = anObject$5(this);
    var pattern = $toString$1(R.source);
    var flags = $toString$1(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$5 = functionCall;
var defineBuiltIn$4 = defineBuiltIn$a;
var regexpExec$1 = regexpExec$2;
var fails$2 = fails$n;
var wellKnownSymbol$4 = wellKnownSymbol$i;
var createNonEnumerableProperty = createNonEnumerableProperty$9;

var SPECIES = wellKnownSymbol$4('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$4(KEY);

  var DELEGATES_TO_SYMBOL = !fails$2(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$2(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$5(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$5(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$4(String.prototype, KEY, methods[0]);
    defineBuiltIn$4(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$9 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
var toString$6 = toString$c;
var requireObjectCoercible$4 = requireObjectCoercible$9;

var charAt$3 = uncurryThis$9(''.charAt);
var charCodeAt = uncurryThis$9(''.charCodeAt);
var stringSlice$4 = uncurryThis$9(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$6(requireObjectCoercible$4($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$3(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$4(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$2 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$2(S, index).length : 1);
};

var uncurryThis$8 = functionUncurryThis;
var toObject = toObject$6;

var floor$1 = Math.floor;
var charAt$1 = uncurryThis$8(''.charAt);
var replace$1 = uncurryThis$8(''.replace);
var stringSlice$3 = uncurryThis$8(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$1(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$3(str, 0, position);
      case "'": return stringSlice$3(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$3(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$1(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$1(ch, 1) : captures[f - 1] + charAt$1(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$4 = functionCall;
var anObject$4 = anObject$c;
var isCallable$2 = isCallable$k;
var classof$2 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$3 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$2(exec)) {
    var result = call$4(exec, R, S);
    if (result !== null) anObject$4(result);
    return result;
  }
  if (classof$2(R) === 'RegExp') return call$4(regexpExec, R, S);
  throw new $TypeError$3('RegExp#exec called on incompatible receiver');
};

var apply = functionApply;
var call$3 = functionCall;
var uncurryThis$7 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var fails$1 = fails$n;
var anObject$3 = anObject$c;
var isCallable$1 = isCallable$k;
var isNullOrUndefined$2 = isNullOrUndefined$5;
var toIntegerOrInfinity = toIntegerOrInfinity$4;
var toLength$2 = toLength$4;
var toString$5 = toString$c;
var requireObjectCoercible$3 = requireObjectCoercible$9;
var advanceStringIndex = advanceStringIndex$1;
var getMethod$2 = getMethod$4;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;
var wellKnownSymbol$3 = wellKnownSymbol$i;

var REPLACE = wellKnownSymbol$3('replace');
var max = Math.max;
var min$2 = Math.min;
var concat = uncurryThis$7([].concat);
var push$2 = uncurryThis$7([].push);
var stringIndexOf = uncurryThis$7(''.indexOf);
var stringSlice$2 = uncurryThis$7(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$1(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$3(this);
      var replacer = isNullOrUndefined$2(searchValue) ? undefined : getMethod$2(searchValue, REPLACE);
      return replacer
        ? call$3(replacer, searchValue, O, replaceValue)
        : call$3(nativeReplace, toString$5(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$3(this);
      var S = toString$5(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$1(replaceValue);
      if (!functionalReplace) replaceValue = toString$5(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec$1(rx, S);
        if (result === null) break;

        push$2(results, result);
        if (!global) break;

        var matchStr = toString$5(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$2(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$5(result[0]);
        var position = max(min$2(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$2(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push$2(replacerArgs, namedCaptures);
          replacement = toString$5(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$2(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$2(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var call$2 = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject$2 = anObject$c;
var isNullOrUndefined$1 = isNullOrUndefined$5;
var requireObjectCoercible$2 = requireObjectCoercible$9;
var sameValue = sameValue$1;
var toString$4 = toString$c;
var getMethod$1 = getMethod$4;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$2(this);
      var searcher = isNullOrUndefined$1(regexp) ? undefined : getMethod$1(regexp, SEARCH);
      return searcher ? call$2(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$4(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject$2(this);
      var S = toString$4(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var $$2 = _export;
var uncurryThis$6 = functionUncurryThisClause;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var toLength$1 = toLength$4;
var toString$3 = toString$c;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$9;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

var stringSlice$1 = uncurryThis$6(''.slice);
var min$1 = Math.min;

var CORRECT_IS_REGEXP_LOGIC$1 = correctIsRegExpLogic$1('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG$1 = !CORRECT_IS_REGEXP_LOGIC$1 && !!function () {
  var descriptor = getOwnPropertyDescriptor$2(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$2({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG$1 && !CORRECT_IS_REGEXP_LOGIC$1 }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString$3(requireObjectCoercible$1(this));
    notARegExp$1(searchString);
    var index = toLength$1(min$1(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$3(searchString);
    return stringSlice$1(that, index, index + search.length) === search;
  }
});

var global$2 = global$i;
var DESCRIPTORS$3 = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$1 = function (name) {
  if (!DESCRIPTORS$3) return global$2[name];
  var descriptor = getOwnPropertyDescriptor$1(global$2, name);
  return descriptor && descriptor.value;
};

var fails = fails$n;
var wellKnownSymbol$2 = wellKnownSymbol$i;
var DESCRIPTORS$2 = descriptors;
var IS_PURE = isPure;

var ITERATOR$2 = wellKnownSymbol$2('iterator');

var urlConstructorDetection = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS$2))
    || !params.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR$2]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var defineBuiltIn$3 = defineBuiltIn$a;

var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn$3(target, key, src[key], options);
  return target;
};

var isPrototypeOf = objectIsPrototypeOf;

var $TypeError$2 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError$2('Incorrect invocation');
};

var classof$1 = classof$8;
var getMethod = getMethod$4;
var isNullOrUndefined = isNullOrUndefined$5;
var Iterators = iterators;
var wellKnownSymbol$1 = wellKnownSymbol$i;

var ITERATOR$1 = wellKnownSymbol$1('iterator');

var getIteratorMethod$2 = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$1)
    || getMethod(it, '@@iterator')
    || Iterators[classof$1(it)];
};

var call$1 = functionCall;
var aCallable = aCallable$5;
var anObject$1 = anObject$c;
var tryToString = tryToString$2;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$1 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject$1(call$1(iteratorMethod, argument));
  throw new $TypeError$1(tryToString(argument) + ' is not iterable');
};

var $TypeError = TypeError;

var validateArgumentsLength$3 = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};

var uncurryThis$5 = functionUncurryThis;

var arraySlice$1 = uncurryThis$5([].slice);

var arraySlice = arraySlice$1;

var floor = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor(length / 2);
    var left = sort(arraySlice(array, 0, middle), comparefn);
    var right = sort(arraySlice(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

var arraySort$1 = sort;

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$1 = _export;
var global$1 = global$i;
var safeGetBuiltIn = safeGetBuiltIn$1;
var call = functionCall;
var uncurryThis$4 = functionUncurryThis;
var DESCRIPTORS$1 = descriptors;
var USE_NATIVE_URL = urlConstructorDetection;
var defineBuiltIn$2 = defineBuiltIn$a;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$4;
var defineBuiltIns = defineBuiltIns$1;
var setToStringTag = setToStringTag$4;
var createIteratorConstructor = iteratorCreateConstructor;
var InternalStateModule = internalState;
var anInstance = anInstance$1;
var isCallable = isCallable$k;
var hasOwn = hasOwnProperty_1;
var bind = functionBindContext;
var classof = classof$8;
var anObject = anObject$c;
var isObject = isObject$d;
var $toString = toString$c;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$5;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var createIterResultObject = createIterResultObject$2;
var validateArgumentsLength$2 = validateArgumentsLength$3;
var wellKnownSymbol = wellKnownSymbol$i;
var arraySort = arraySort$1;

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$1.RegExp;
var TypeError$1 = global$1.TypeError;
var decodeURIComponent$1 = global$1.decodeURIComponent;
var encodeURIComponent$1 = global$1.encodeURIComponent;
var charAt = uncurryThis$4(''.charAt);
var join = uncurryThis$4([].join);
var push$1 = uncurryThis$4([].push);
var replace = uncurryThis$4(''.replace);
var shift = uncurryThis$4([].shift);
var splice = uncurryThis$4([].splice);
var split = uncurryThis$4(''.split);
var stringSlice = uncurryThis$4(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent$1(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent$1(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw new TypeError$1('Expected sequence with length 2');
        push$1(entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push$1(entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push$1(entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$1(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype$3);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS$1) this.size = state.entries.length;
};

var URLSearchParamsPrototype$3 = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype$3, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$2(arguments.length, 2);
    push$1(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS$1) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength$2(arguments.length, 1);
    var entries = state.entries;
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS$1) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength$2(arguments.length, 1);
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength$2(arguments.length, 1);
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$1(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength$2(arguments.length, 1);
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$2(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$1(entries, { key: key, value: val });
    if (!DESCRIPTORS$1) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn$2(URLSearchParamsPrototype$3, ITERATOR, URLSearchParamsPrototype$3.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn$2(URLSearchParamsPrototype$3, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS$1) defineBuiltInAccessor$1(URLSearchParamsPrototype$3, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$1({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis$4(HeadersPrototype.has);
  var headersSet = uncurryThis$4(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $$1({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$1({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var defineBuiltIn$1 = defineBuiltIn$a;
var uncurryThis$3 = functionUncurryThis;
var toString$2 = toString$c;
var validateArgumentsLength$1 = validateArgumentsLength$3;

var $URLSearchParams$1 = URLSearchParams;
var URLSearchParamsPrototype$2 = $URLSearchParams$1.prototype;
var append = uncurryThis$3(URLSearchParamsPrototype$2.append);
var $delete = uncurryThis$3(URLSearchParamsPrototype$2['delete']);
var forEach$1 = uncurryThis$3(URLSearchParamsPrototype$2.forEach);
var push = uncurryThis$3([].push);
var params$1 = new $URLSearchParams$1('a=1&a=2&b=3');

params$1['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params$1['delete']('b', undefined);

if (params$1 + '' !== 'a=2') {
  defineBuiltIn$1(URLSearchParamsPrototype$2, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach$1(this, function (v, k) { // also validates `this`
      push(entries, { key: k, value: v });
    });
    validateArgumentsLength$1(length, 1);
    var key = toString$2(name);
    var value = toString$2($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}

var defineBuiltIn = defineBuiltIn$a;
var uncurryThis$2 = functionUncurryThis;
var toString$1 = toString$c;
var validateArgumentsLength = validateArgumentsLength$3;

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype$1 = $URLSearchParams.prototype;
var getAll = uncurryThis$2(URLSearchParamsPrototype$1.getAll);
var $has = uncurryThis$2(URLSearchParamsPrototype$1.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn(URLSearchParamsPrototype$1, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString$1($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}

var DESCRIPTORS = descriptors;
var uncurryThis$1 = functionUncurryThis;
var defineBuiltInAccessor = defineBuiltInAccessor$4;

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis$1(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}

const omitPropKeys = [...wsLayoutOmitPropKeys, 'subApp', 'path', 'params', 'pageTitle', 'exact', 'subRouteMenuItems', 'hideTopNavigation', 'hrefProps'];
const spaBasenameBySubApp = {
  hr: '',
  er: 'employee-records',
  doc: 'adhoc-doc',
  survey: 'worker-survey',
  'talent-network': 'talent-network',
  payroll: 'payroll',
  'time-off': 'time-off',
  hris: 'hris',
  'knowledge-base': 'knowledge-base'
};
const isSubAppRoute = (pathname, subApp) => {
  return pathname.startsWith(`/${subApp}`) || pathname.startsWith(`/${spaBasenameBySubApp[subApp]}`);
};
const getPathFromItem = (item, options = {}) => {
  var _a, _b, _c;
  const {
    isMfe = true,
    routerType = 'hash'
  } = options;
  if (item.type || item.children || item.onClick || item.href) {
    return null;
  }
  const subApp = (_a = item.subApp) !== null && _a !== void 0 ? _a : routerType === 'browser' ? '' : 'hr';
  // e.g. hr, er, doc, survey
  const mfeBasename = subApp;
  // e.g. '', employee-records, adhoc-doc, worker-survey
  const spaBasename = spaBasenameBySubApp[subApp || 'hr'];
  // e.g. #, employee-records/#, adhoc-doc/#, worker-survey/#
  const spaBaseNameWithHash = spaBasename ? `${spaBasename}/#` : '#';
  const subAppBasename = isMfe || routerType === 'browser' ? mfeBasename : spaBaseNameWithHash;
  const path = (_b = item.path) !== null && _b !== void 0 ? _b : `/${item.index}`;
  const search = qs.stringify((_c = item.params) !== null && _c !== void 0 ? _c : {}, {
    addQueryPrefix: true
  });
  return {
    path: `${subAppBasename ? `/${subAppBasename}` : ''}${path}`,
    search,
    fullUrl: `${subAppBasename ? `/${subAppBasename}` : ''}${path}${search}`
  };
};
const doesMenuItemParamsMatch = options => {
  const {
    item,
    location
  } = options;
  if (!item.params) return true;
  const paramKeys = Object.keys(item.params);
  const paramValues = Object.values(item.params);
  const locationParams = new URLSearchParams(location.search);
  return paramKeys.every((param, index) => {
    var _a;
    const paramValue = paramValues[index];
    const locationParamValue = (_a = locationParams.get(param)) !== null && _a !== void 0 ? _a : '';
    if (paramValue instanceof RegExp) {
      return paramValue.test(locationParamValue);
    }
    return locationParamValue === paramValue;
  });
};
const isMenuItemSelected = options => {
  var _a;
  const {
    item,
    location,
    windowLocation,
    isMfe = true,
    routerType = 'hash'
  } = options;
  const pathObjOrNull = getPathFromItem(item, {
    isMfe,
    routerType
  });
  if (!pathObjOrNull) return false;
  const {
    path
  } = pathObjOrNull;
  const pathname = isMfe ? location.pathname : routerType === 'hash' ? `${(_a = windowLocation === null || windowLocation === void 0 ? void 0 : windowLocation.pathname) !== null && _a !== void 0 ? _a : '/'}#${location.pathname}` : location.pathname;
  const isItemSelected = pathname.startsWith(path) && (!item.exact || pathname === path) && doesMenuItemParamsMatch(options);
  const isSubRouteMenuItemsMatch = () => {
    var _a, _b;
    return !!((_b = (_a = item.subRouteMenuItems) === null || _a === void 0 ? void 0 : _a.some) === null || _b === void 0 ? void 0 : _b.call(_a, additionalMatch => {
      return isMenuItemSelected(Object.assign(Object.assign({}, options), {
        item: Object.assign(Object.assign(Object.assign({}, item), additionalMatch), {
          subRouteMenuItems: []
        })
      }));
    }));
  };
  return isItemSelected || !!isSubRouteMenuItemsMatch();
};
const getSelectedMenuItemsByLocation = options => {
  const {
    menuItems,
    location
  } = options;
  const selectedItems = menuItems.flatMap(item => {
    var _a;
    if ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) {
      return getSelectedMenuItemsByLocation(Object.assign(Object.assign({}, options), {
        menuItems: item.children
      }));
    }
    if (item.selected) {
      return item.selected(location, item) ? [item] : [];
    }
    return isMenuItemSelected(Object.assign(Object.assign({}, options), {
      item
    })) ? [item] : [];
  });
  return selectedItems;
};
const getSelectedIndexesFromLocation = options => {
  return getSelectedMenuItemsByLocation(options).map(item => item.index);
};
const getSelectedMenuItemsFromSelectedIndexes = (menuItems, selectedIndexes, options = {}) => {
  const selectedItems = menuItems.flatMap(item => {
    var _a;
    if ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) {
      return getSelectedMenuItemsFromSelectedIndexes(item.children, selectedIndexes, options);
    }
    if (selectedIndexes.includes(item.index)) {
      return [item];
    }
    return [];
  });
  return selectedItems;
};
const addParentToMenuItems = menuItems => {
  return menuItems.map(item => {
    var _a;
    if ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) {
      item.children.forEach(child => {
        child.parent = item;
      });
      addParentToMenuItems(item.children);
    }
    return item;
  });
};
const getRootParent = item => {
  if (item.parent) {
    return getRootParent(item.parent);
  }
  return item;
};
const getDefaultOpenKeysFromSelectedIndexes = (menuItems, selectedIndexes, options = {}) => {
  const defaultOpenKeys = menuItems.flatMap(item => {
    var _a;
    if ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) {
      if (item.type !== 'group' && item.children.some(child => selectedIndexes.includes(child.index))) {
        return [item.index];
      }
      return getDefaultOpenKeysFromSelectedIndexes(item.children, selectedIndexes, options);
    }
    return [];
  });
  return defaultOpenKeys;
};
const getBackToUrl = (item, options) => {
  var _a, _b, _c, _d;
  const {
    isMfe,
    location,
    defaultUrl
  } = options;
  const {
    state
  } = location;
  if (state === null || state === void 0 ? void 0 : state.backToUrl) {
    return state.backToUrl;
  }
  const selectedMenuItemPathObj = item ? getPathFromItem(item, {
    isMfe: isMfe
  }) : null;
  const subApp = (_a = item === null || item === void 0 ? void 0 : item.subApp) !== null && _a !== void 0 ? _a : 'hr';
  const spaBasename = spaBasenameBySubApp[subApp] ? `/${spaBasenameBySubApp[subApp]}` : '';
  const search = qs.stringify((_b = item === null || item === void 0 ? void 0 : item.params) !== null && _b !== void 0 ? _b : {}, {
    addQueryPrefix: true
  });
  const locationPathName = ((_c = location === null || location === void 0 ? void 0 : location.pathname) === null || _c === void 0 ? void 0 : _c.startsWith('/')) ? location === null || location === void 0 ? void 0 : location.pathname : `/${location === null || location === void 0 ? void 0 : location.pathname}`;
  // The getBackToUrl function constructs a back navigation URL by combining the sub-app basename
  // and location.pathname from ReactRouterLocation, in the format: /<sub-app-basename>/<location.pathname>
  //
  // The location.pathname needs the sub-app basename prefix because when a sub-app initializes
  // the location object, it configures a basename in the router (BrowserRouter/HashRouter).
  // This basename means location.pathname returns a path relative to the basename, while
  // window.location.pathname contains the full path: <basename>/<location.pathname>
  //
  // This pattern works well for standalone sub-apps, but breaks when converting to micro-frontends.
  // In MFE mode, the host app initializes location without a basename, causing duplicate prefixes
  // in the final pathname. We must handle this by removing duplicates while maintaining backwards
  // compatibility.
  //
  // Note:
  // 1. This is a temporary workaround, not an ideal solution
  // 2. A full rewrite of getBackToUrl would be too complex at this time
  // 3. We can implement a cleaner solution after completing the MFE migration
  const ignoreSpaPrefix = (_d = window.__WS_CTX__) === null || _d === void 0 ? void 0 : _d.TEMP_MFE_ROUTE_PREFIXES.some(prefix => window.location.pathname.startsWith(prefix));
  const pathnameWithHash = ignoreSpaPrefix ? `/#${locationPathName}${search}` : `${spaBasename}/#${locationPathName}${search}`;
  const pathname = ignoreSpaPrefix ? `${locationPathName}${search}` : `${spaBasename}${locationPathName}${search}`;
  const mainRoute = (selectedMenuItemPathObj === null || selectedMenuItemPathObj === void 0 ? void 0 : selectedMenuItemPathObj.fullUrl) || (item === null || item === void 0 ? void 0 : item.href);
  const routeRegArr = [new RegExp(`^${window.location.origin}${mainRoute}(\\?.*)?$`)];
  if (mainRoute === null || mainRoute === void 0 ? void 0 : mainRoute.startsWith('/#')) {
    routeRegArr.push(new RegExp(`^${window.location.origin}${mainRoute === null || mainRoute === void 0 ? void 0 : mainRoute.replace('/#', '')}(\\?.*)?$`));
  }
  const shouldUseDefaultUrl = routeRegArr.some(reg => reg.test(defaultUrl || ''));
  const backUrl = shouldUseDefaultUrl ? defaultUrl === null || defaultUrl === void 0 ? void 0 : defaultUrl.replace(`${window.location.origin}`, '') : mainRoute;
  const isInMainRoute = mainRoute === pathname || mainRoute === pathnameWithHash;
  return !isInMainRoute ? backUrl : undefined;
};
const buildLiteMenuItems = menuItems => {
  return menuItems.map(item => {
    if (item.upsellOnLite) {
      const {
          upsellOnLite
        } = item,
        menuItemProps = __rest(item, ["upsellOnLite"]);
      return Object.assign(Object.assign(Object.assign({}, menuItemProps), {
        children: undefined,
        subRouteMenuItems: undefined,
        hideWhenConditionMatch: true
      }), typeof upsellOnLite === 'boolean' ? {} : upsellOnLite);
    }
    return Object.assign(Object.assign({}, item), {
      children: item.children ? buildLiteMenuItems(item.children) : undefined
    });
  });
};

const Layout = /*#__PURE__*/styled.div.withConfig({
  displayName: "app-layoutstyles__Layout",
  componentId: "sc-1t9coxc-0"
})(["display:flex;flex-direction:row;min-height:100vh;width:100vw;"]);
const Navigation = /*#__PURE__*/styled.div.withConfig({
  displayName: "app-layoutstyles__Navigation",
  componentId: "sc-1t9coxc-1"
})(["position:fixed;top:0;left:0;min-height:100vh;width:100vw;"]);
const Content = /*#__PURE__*/styled.div.withConfig({
  displayName: "app-layoutstyles__Content",
  componentId: "sc-1t9coxc-2"
})(["position:relative;display:flex;flex-direction:column;flex-grow:1;"]);
const AccountSwitcherModal = /*#__PURE__*/styled(_a => {
  var {
      className
    } = _a,
    otherProps = __rest(_a, ["className"]);
  return jsx(Modal, Object.assign({
    wrapClassName: className
  }, otherProps));
}).withConfig({
  displayName: "app-layoutstyles__AccountSwitcherModal",
  componentId: "sc-1t9coxc-3"
})(["& .antd4-modal-content{border-radius:4px;}& .antd4-modal-body{padding:16px;}"]);
const S$1 = {
  Layout,
  Navigation,
  Content,
  AccountSwitcherModal
};

var queryString = {};

var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

var decodeUriComponent = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};

var splitOnFirst = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};

var filterObj = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};

(function (exports) {
const strictUriEncode$1 = strictUriEncode;
const decodeComponent = decodeUriComponent;
const splitOnFirst$1 = splitOnFirst;
const filterObject = filterObj;

const isNullOrUndefined = value => value === null || value === undefined;

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
			return key => (result, value) => {
				if (value === null || value === undefined || value.length === 0) {
					return result;
				}

				if (result.length === 0) {
					return [[encode(key, options), '=', encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst$1(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${encode(object.fragmentIdentifier, options)}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};
}(queryString));

// ignore waring `"export 'useNavigate' (imported as 'rc') was not found in 'react-router'`
const rc = tmp;
const baseParseConfig = {
  parseNumbers: false,
  parseBooleans: false
};
const baseStringifyConfig = {
  skipNull: false,
  skipEmptyString: false
};
const useUrlState = (initialState, options) => {
  var _a, _b;
  const {
    navigateMode = 'push',
    parseOptions,
    stringifyOptions
  } = options || {};
  const mergedParseOptions = Object.assign(Object.assign({}, baseParseConfig), parseOptions);
  const mergedStringifyOptions = Object.assign(Object.assign({}, baseStringifyConfig), stringifyOptions);
  const location = rc.useLocation();
  // react-router v5
  const history = (_a = rc.useHistory) === null || _a === void 0 ? void 0 : _a.call(rc);
  // react-router v6
  const navigate = (_b = rc.useNavigate) === null || _b === void 0 ? void 0 : _b.call(rc);
  const update = useUpdate();
  const initialStateRef = useRef(typeof initialState === 'function' ? initialState() : initialState || {});
  const queryFromUrl = useMemo(() => {
    return queryString.parse(location.search, mergedParseOptions);
  }, [location.search]);
  const targetQuery = useMemo(() => Object.assign(Object.assign({}, initialStateRef.current), queryFromUrl), [queryFromUrl]);
  const setState = s => {
    const newQuery = typeof s === 'function' ? s(targetQuery) : s;
    // 1. 如果 setState 后，search 没变化，就需要 update 来触发一次更新。比如 demo1 直接点击 clear，就需要 update 来触发更新。
    // 2. update 和 history 的更新会合并，不会造成多次更新
    update();
    if (history) {
      history[navigateMode]({
        hash: location.hash,
        search: queryString.stringify(Object.assign(Object.assign({}, queryFromUrl), newQuery), mergedStringifyOptions) || '?'
      }, location.state);
    }
    if (navigate) {
      navigate({
        hash: location.hash,
        search: queryString.stringify(Object.assign(Object.assign({}, queryFromUrl), newQuery), mergedStringifyOptions) || '?'
      }, {
        replace: navigateMode === 'replace',
        state: location.state
      });
    }
  };
  return [targetQuery, useMemoizedFn(setState)];
};

var $ = _export;
var uncurryThis = functionUncurryThisClause;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength = toLength$4;
var toString = toString$c;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$9;
var correctIsRegExpLogic = correctIsRegexpLogic;

var slice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return slice(that, end - search.length, end) === search;
  }
});

const createBroadCastChannel = channel => {
  let bc;
  try {
    bc = new BroadcastChannel(channel);
  } catch (e) {
    bc = {
      onmessage: {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      postMessage: () => {}
    };
  }
  return bc;
};

const FlexWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "account-switcherstyles__FlexWrapper",
  componentId: "sc-xup4ll-0"
})(["display:flex;width:100%;justify-content:", ";align-items:", ";flex-direction:", ";"], props => props.direction === 'row' ? props.position : 'center', props => props.direction === 'column' ? props.position : 'center', props => props.direction || 'column');
const S = {
  FlexWrapper
};

var logo = "data:image/svg+xml,%3Csvg%20width%3D%22224%22%20height%3D%2250%22%20viewBox%3D%220%200%20224%2050%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20d%3D%22M48.7647%208.94057C48.5451%206.87113%2047.6286%204.93993%2046.168%203.46852C44.7074%201.99711%2042.7907%201.07428%2040.7371%200.85368C30.1501%20-0.28456%2019.473%20-0.28456%208.886%200.85368C6.83034%201.07184%204.91103%201.99359%203.44814%203.46522C1.98526%204.93685%201.06722%206.86939%200.847124%208.94057C-0.282375%2019.6095%20-0.282375%2030.3693%200.847124%2041.0382C1.06312%2043.1107%201.97793%2045.0459%203.43888%2046.5207C4.89982%2047.9955%206.81851%2048.9208%208.87472%2049.1421C19.4614%2050.286%2030.1391%2050.286%2040.7258%2049.1421C42.7823%2048.9237%2044.7023%2048.0012%2046.1653%2046.5284C47.6283%2045.0556%2048.5458%2043.1217%2048.7647%2041.0495C49.895%2030.3769%2049.895%2019.6133%2048.7647%208.94057Z%22%20fill%3D%22%23457CFF%22%20%2F%3E%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M19.1094%2020.1154C17.6297%2020.2721%2016.1171%2021.03%2014.5687%2022.5721C14.0396%2023.099%2013.1868%2023.0939%2012.6639%2022.5607C12.1411%2022.0275%2012.1461%2021.168%2012.6752%2020.6411C14.5348%2018.7891%2016.5866%2017.6529%2018.8278%2017.4155C21.069%2017.1781%2023.3103%2017.8595%2025.5113%2019.2814C27.344%2020.4653%2028.9799%2020.8897%2030.4596%2020.733C31.9392%2020.5762%2033.4518%2019.8184%2035.0003%2018.2763C35.5294%2017.7493%2036.3821%2017.7544%2036.905%2018.2877C37.4279%2018.8209%2037.4228%2019.6804%2036.8937%2020.2073C35.0341%2022.0593%2032.9823%2023.1955%2030.7412%2023.4329C28.5%2023.6703%2026.2586%2022.9888%2024.0576%2021.567C22.2249%2020.383%2020.589%2019.9587%2019.1094%2020.1154Z%22%20fill%3D%22%23FDFDFD%22%20%2F%3E%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M19.1094%2029.3413C17.6297%2029.498%2016.1171%2030.2559%2014.5687%2031.7979C14.0396%2032.3249%2013.1868%2032.3198%2012.6639%2031.7866C12.1411%2031.2533%2012.1461%2030.3939%2012.6752%2029.8669C14.5348%2028.015%2016.5866%2026.8787%2018.8278%2026.6413C21.069%2026.4039%2023.3103%2027.0854%2025.5113%2028.5073C27.344%2029.6912%2028.9799%2030.1156%2030.4596%2029.9588C31.9392%2029.8021%2033.4518%2029.0442%2035.0003%2027.5021C35.5294%2026.9752%2036.3821%2026.9803%2036.905%2027.5135C37.4279%2028.0468%2037.4228%2028.9062%2036.8937%2029.4332C35.0341%2031.2851%2032.9823%2032.4214%2030.7412%2032.6588C28.5%2032.8962%2026.2586%2032.2147%2024.0576%2030.7928C22.2249%2029.6089%2020.589%2029.1845%2019.1094%2029.3413Z%22%20fill%3D%22%23FDFDFD%22%20%2F%3E%20%20%3Cpath%20d%3D%22M67.0614%2032.1723H70.5507L73.9594%2022.6144L77.3412%2032.1723H80.8304L85.9032%2017.262H81.7161L78.8711%2025.9187L75.704%2017.262H72.2147L69.0208%2025.9187L66.1757%2017.262H62.0155L67.0614%2032.1723Z%22%20fill%3D%22%23464D5D%22%20%2F%3E%20%20%3Cpath%20d%3D%22M94.6891%2032.5C96.1385%2032.5%2097.4537%2032.1632%2098.6346%2031.4896C99.8156%2030.816%20100.755%2029.8966%20101.453%2028.7315C102.169%2027.5481%20102.526%2026.21%20102.526%2024.7172C102.526%2023.2061%20102.169%2021.868%20101.453%2020.7029C100.755%2019.5377%2099.8156%2018.6183%2098.6346%2017.9447C97.4537%2017.2711%2096.1385%2016.9343%2094.6891%2016.9343C93.2398%2016.9343%2091.9157%2017.2711%2090.7168%2017.9447C89.5358%2018.6183%2088.5875%2019.5377%2087.8718%2020.7029C87.1739%2021.868%2086.825%2023.2061%2086.825%2024.7172C86.825%2026.21%2087.1739%2027.5481%2087.8718%2028.7315C88.5875%2029.8966%2089.5358%2030.816%2090.7168%2031.4896C91.9157%2032.1632%2093.2398%2032.5%2094.6891%2032.5ZM94.6891%2028.8134C93.5976%2028.8134%2092.703%2028.4311%2092.0051%2027.6665C91.3252%2026.9018%2090.9852%2025.9187%2090.9852%2024.7172C90.9852%2023.5338%2091.3252%2022.5598%2092.0051%2021.7952C92.703%2021.0124%2093.5976%2020.6209%2094.6891%2020.6209C95.7806%2020.6209%2096.6664%2021.0124%2097.3463%2021.7952C98.0263%2022.5598%2098.3662%2023.5338%2098.3662%2024.7172C98.3662%2025.9187%2098.0263%2026.9018%2097.3463%2027.6665C96.6664%2028.4311%2095.7806%2028.8134%2094.6891%2028.8134Z%22%20fill%3D%22%23464D5D%22%20%2F%3E%20%20%3Cpath%20d%3D%22M104.898%2032.1723H108.924V24.1437C108.924%2023.0332%20109.228%2022.1775%20109.837%2021.5767C110.445%2020.9577%20111.241%2020.6482%20112.226%2020.6482H113.487V17.0982H112.628C111.734%2017.0982%20110.937%2017.2711%20110.239%2017.617C109.559%2017.9447%20109.032%2018.5728%20108.656%2019.5013V17.262H104.898V32.1723Z%22%20fill%3D%22%23464D5D%22%20%2F%3E%20%20%3Cpath%20d%3D%22M115.252%2032.1723H119.278V27.6118L120.888%2025.8095L124.619%2032.1723H129.182L123.894%2023.2698L129.208%2017.262H124.243L119.278%2022.6417V11.5H115.252V32.1723Z%22%20fill%3D%22%23464D5D%22%20%2F%3E%20%20%3Cpath%20d%3D%22M136.722%2032.5C138.422%2032.5%20139.791%2032.0722%20140.829%2031.2165C141.866%2030.3609%20142.385%2029.2412%20142.385%2027.8576C142.385%2026.7835%20142.063%2025.8823%20141.419%2025.1541C140.775%2024.4077%20139.844%2023.8524%20138.628%2023.4883L136.293%2022.7783C135.237%2022.4688%20134.709%2022.0228%20134.709%2021.4402C134.709%2021.0579%20134.852%2020.7575%20135.138%2020.539C135.443%2020.3205%20135.854%2020.2113%20136.373%2020.2113C137.089%2020.2113%20137.724%2020.4025%20138.279%2020.7848C138.851%2021.1489%20139.245%2021.6404%20139.46%2022.2594L142.439%2020.8394C141.992%2019.6014%20141.222%2018.6456%20140.131%2017.972C139.057%2017.2802%20137.805%2016.9343%20136.373%2016.9343C135.282%2016.9343%20134.315%2017.1346%20133.474%2017.5351C132.633%2017.9174%20131.98%2018.4545%20131.515%2019.1463C131.05%2019.8381%20130.817%2020.6482%20130.817%2021.5767C130.817%2022.6326%20131.139%2023.552%20131.783%2024.3349C132.428%2025.0995%20133.349%2025.6547%20134.548%2026.0006L137.044%2026.7107C138.01%2026.9837%20138.493%2027.4207%20138.493%2028.0215C138.493%2028.9135%20137.903%2029.3596%20136.722%2029.3596C135.935%2029.3596%20135.219%2029.132%20134.575%2028.6769C133.931%2028.2217%20133.421%2027.5936%20133.045%2026.7926L130.093%2028.2126C130.522%2029.5234%20131.327%2030.5702%20132.508%2031.3531C133.707%2032.1177%20135.112%2032.5%20136.722%2032.5Z%22%20fill%3D%22%23464D5D%22%20%2F%3E%20%20%3Cpath%20d%3D%22M151.85%2032.3362C152.155%2032.3362%20152.477%2032.3179%20152.817%2032.2815C153.157%2032.2451%20153.461%2032.2087%20153.729%2032.1723V28.7042C153.353%2028.7588%20153.04%2028.7861%20152.79%2028.7861C151.126%2028.7861%20150.294%2028.0306%20150.294%2026.5195V20.8121H153.729V17.262H150.294V13.8758H146.268V14.9681C146.268%2016.4974%20145.489%2017.262%20143.933%2017.262H143.798V20.8121H146.268V26.7926C146.268%2028.5403%20146.751%2029.9057%20147.717%2030.8888C148.701%2031.8537%20150.079%2032.3362%20151.85%2032.3362Z%22%20fill%3D%22%23464D5D%22%20%2F%3E%20%20%3Cpath%20d%3D%22M156.088%2032.1723H160.114V24.1437C160.114%2023.0332%20160.419%2022.1775%20161.027%2021.5767C161.635%2020.9577%20162.432%2020.6482%20163.416%2020.6482H164.677V17.0982H163.818C162.924%2017.0982%20162.127%2017.2711%20161.43%2017.617C160.75%2017.9447%20160.222%2018.5728%20159.846%2019.5013V17.262H156.088V32.1723Z%22%20fill%3D%22%23464D5D%22%20%2F%3E%20%20%3Cpath%20d%3D%22M173.501%2032.5C175.004%2032.5%20176.319%2032.1723%20177.446%2031.5169C178.574%2030.8433%20179.361%2029.9603%20179.808%2028.868L176.587%2027.3114C176.301%2027.8212%20175.898%2028.2217%20175.38%2028.513C174.879%2028.8043%20174.27%2028.9499%20173.554%2028.9499C172.57%2028.9499%20171.765%2028.6677%20171.139%2028.1034C170.513%2027.539%20170.146%2026.7926%20170.038%2025.8641H180.291C180.363%2025.6638%20180.408%2025.4272%20180.425%2025.1541C180.461%2024.8628%20180.479%2024.5715%20180.479%2024.2802C180.479%2022.8966%20180.193%2021.6586%20179.62%2020.5663C179.066%2019.4558%20178.251%2018.5728%20177.178%2017.9174C176.104%2017.262%20174.789%2016.9343%20173.232%2016.9343C171.837%2016.9343%20170.584%2017.2711%20169.475%2017.9447C168.365%2018.6183%20167.48%2019.5377%20166.818%2020.7029C166.173%2021.868%20165.851%2023.197%20165.851%2024.6899C165.851%2026.1281%20166.164%2027.4389%20166.791%2028.6222C167.417%2029.8056%20168.303%2030.7523%20169.448%2031.4623C170.593%2032.1541%20171.944%2032.5%20173.501%2032.5ZM173.232%2020.2113C174.055%2020.2113%20174.735%2020.4571%20175.272%2020.9486C175.809%2021.4402%20176.122%2022.0774%20176.212%2022.8602H170.119C170.316%2022.0046%20170.683%2021.3492%20171.219%2020.894C171.774%2020.4389%20172.445%2020.2113%20173.232%2020.2113Z%22%20fill%3D%22%23464D5D%22%20%2F%3E%20%20%3Cpath%20d%3D%22M187.386%2032.5C189.211%2032.5%20190.678%2031.9265%20191.788%2030.7796V32.1723H195.545V22.3414C195.545%2021.2672%20195.277%2020.3296%20194.74%2019.5286C194.221%2018.7094%20193.488%2018.0722%20192.539%2017.617C191.591%2017.1619%20190.499%2016.9343%20189.265%2016.9343C187.708%2016.9343%20186.339%2017.2984%20185.158%2018.0267C183.995%2018.7549%20183.199%2019.738%20182.769%2020.9759L185.99%2022.5325C186.241%2021.8771%20186.634%2021.3492%20187.171%2020.9486C187.726%2020.5481%20188.361%2020.3479%20189.077%2020.3479C189.828%2020.3479%20190.419%2020.539%20190.848%2020.9213C191.296%2021.3036%20191.519%2021.777%20191.519%2022.3414V22.751L187.466%2023.4064C185.713%2023.6977%20184.407%2024.2529%20183.548%2025.0722C182.689%2025.8914%20182.259%2026.9291%20182.259%2028.1853C182.259%2029.5325%20182.716%2030.5884%20183.628%2031.3531C184.559%2032.1177%20185.811%2032.5%20187.386%2032.5ZM186.42%2028.0488C186.42%2027.5572%20186.572%2027.184%20186.876%2026.9291C187.18%2026.656%20187.618%2026.4649%20188.191%2026.3557L191.519%2025.7549V26.2191C191.519%2027.1294%20191.215%2027.9031%20190.607%2028.5403C189.998%2029.1775%20189.193%2029.4961%20188.191%2029.4961C187.69%2029.4961%20187.27%2029.3687%20186.93%2029.1138C186.59%2028.8589%20186.42%2028.5039%20186.42%2028.0488Z%22%20fill%3D%22%23464D5D%22%20%2F%3E%20%20%3Cpath%20d%3D%22M198.498%2032.1723H202.524V23.461C202.524%2022.6053%20202.748%2021.9226%20203.195%2021.4129C203.66%2020.8849%20204.286%2020.6209%20205.074%2020.6209C205.861%2020.6209%20206.478%2020.8849%20206.926%2021.4129C207.391%2021.9226%20207.624%2022.6053%20207.624%2023.461V32.1723H211.65V23.461C211.65%2022.6053%20211.873%2021.9226%20212.321%2021.4129C212.786%2020.8849%20213.412%2020.6209%20214.199%2020.6209C214.987%2020.6209%20215.604%2020.8849%20216.051%2021.4129C216.517%2021.9226%20216.749%2022.6053%20216.749%2023.461V32.1723H220.775V22.5871C220.775%2021.4584%20220.543%2020.4753%20220.077%2019.6378C219.612%2018.7822%20218.968%2018.1177%20218.145%2017.6443C217.34%2017.171%20216.409%2016.9343%20215.354%2016.9343C214.405%2016.9343%20213.537%2017.1255%20212.75%2017.5078C211.981%2017.8719%20211.336%2018.4454%20210.818%2019.2282C210.406%2018.5182%20209.798%2017.9629%20208.992%2017.5624C208.205%2017.1437%20207.328%2016.9343%20206.362%2016.9343C205.432%2016.9343%20204.608%2017.1164%20203.893%2017.4805C203.177%2017.8264%20202.631%2018.3635%20202.256%2019.0917V17.262H198.498V32.1723Z%22%20fill%3D%22%23464D5D%22%20%2F%3E%3C%2Fsvg%3E%20%20";

const Title = /*#__PURE__*/styled.span.withConfig({
  displayName: "account-switcher__Title",
  componentId: "sc-uyhq4c-0"
})(["font-weight:600;font-size:16px;line-height:20px;color:rgb(39,39,42);font-family:'Plus Jakarta Sans',sans-serif;margin:25px 0 20px 0;"]);
const Row = /*#__PURE__*/styled.div.withConfig({
  displayName: "account-switcher__Row",
  componentId: "sc-uyhq4c-1"
})(["border-bottom:1px solid rgb(212,212,216);cursor:pointer;padding:12px;font-family:'Plus Jakarta Sans',sans-serif;font-weight:400;&:hover{background-color:rgb(249,250,251);}"]);
const Input = /*#__PURE__*/styled(Input$1).withConfig({
  displayName: "account-switcher__Input",
  componentId: "sc-uyhq4c-2"
})(() => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["&.", "-input-affix-wrapper{border-radius:8px;}&.", "-input-affix-wrapper:not(.", "-input-affix-wrapper-disabled):hover{border-color:rgb(120,120,131);}"], antdCssPrefix, antdCssPrefix, antdCssPrefix);
});
const AccountSwitcher = () => {
  const {
    t
  } = useTranslation('app-global-components');
  const [searchStr, setSearchStr] = useState('');
  const [companies, setCompanies] = useState([]);
  const companyList = useMemo(() => {
    return companies === null || companies === void 0 ? void 0 : companies.filter(item => {
      const companeName = ((item === null || item === void 0 ? void 0 : item.name) || '').toLowerCase();
      return companeName === null || companeName === void 0 ? void 0 : companeName.includes(searchStr.toLowerCase());
    });
  }, [companies, searchStr]);
  function onClickCompany({
    id,
    uuid
  }) {
    wsLocalStorage.removeItem('WS_NEED_TO_SELECT_COMPANY');
    wsLocalStorage.removeItem('PAYROLL_COMPANY_ID');
    wsLocalStorage.setItem('WS_SELECTED_COMPANY', String(id));
    wsLocalStorage.setItem('CORE_COMPANY_ID', uuid);
    const bc = createBroadCastChannel('multi-login-detector');
    bc.postMessage('multi-login-detecteed');
    getNavigateFn()('/');
    window.location.reload();
  }
  useEffect(() => {
    service.company.fetchCompanies().then(data => {
      // Since this companent will be re-written by rangers in a couple of months, so types won't be defined this time
      setCompanies((data === null || data === void 0 ? void 0 : data.companies) || []);
    }).catch(() => {
      message.error('Error while getting companies');
    });
  }, []);
  return jsxs(S.FlexWrapper, {
    direction: "column",
    position: "center",
    style: {
      padding: '20px 0',
      width: '300px',
      margin: 'auto'
    },
    children: [jsx("img", {
      src: logo,
      alt: t('logo'),
      style: {
        width: '224px',
        height: '50px'
      }
    }), jsx(Title, {
      children: t('Choose an account')
    }), jsx(Input, {
      suffix: jsx(SearchOutlined, {}),
      size: "large",
      value: searchStr,
      placeholder: t('Search companies'),
      onChange: e => {
        const {
          value
        } = e.target;
        setSearchStr(value);
      }
    }), jsx(S.FlexWrapper, {
      direction: "column",
      style: {
        marginTop: '12px'
      },
      children: companyList === null || companyList === void 0 ? void 0 : companyList.map(cInfo => jsx(Row, {
        onClick: () => {
          onClickCompany({
            id: cInfo === null || cInfo === void 0 ? void 0 : cInfo.id,
            uuid: cInfo === null || cInfo === void 0 ? void 0 : cInfo.uuid
          });
        },
        children: cInfo === null || cInfo === void 0 ? void 0 : cInfo.name
      }, cInfo === null || cInfo === void 0 ? void 0 : cInfo.id))
    })]
  });
};

const AccountSwitchLabel = () => {
  const [open, setOpen] = useState(false);
  const {
    t
  } = useTranslation('app-global-components');
  return jsxs(Fragment, {
    children: [jsx(Menu.ItemLabel, {
      onClick: () => setOpen(!open),
      children: t('Switch account')
    }), open && jsx(S$1.AccountSwitcherModal, {
      open: open,
      footer: null,
      onCancel: () => {
        setOpen(false);
      },
      children: jsx(AccountSwitcher, {})
    })]
  });
};

const TalentNetworkPageTitle = () => {
  const location = useLocation();
  const {
    t
  } = useTranslation('app-global-components');
  return location.pathname === '/prospects' ? t('Prospects') : t('Talent Network');
};

const Logo = /*#__PURE__*/styled.img.withConfig({
  displayName: "brand-item__Logo",
  componentId: "sc-xbv4af-0"
})(["width:60px;height:60px;border-radius:50%;flex-shrink:0;object-fit:cover;background:#f0f0f0;"]);
const LogoPlaceholder = /*#__PURE__*/styled(Box).withConfig({
  displayName: "brand-item__LogoPlaceholder",
  componentId: "sc-xbv4af-1"
})(["width:60px;height:60px;border-radius:50%;flex-shrink:0;background-color:", ";display:flex;align-items:center;justify-content:center;"], colors.gray300);
const BrandItemContainer = /*#__PURE__*/styled(FlexBox).withConfig({
  displayName: "brand-item__BrandItemContainer",
  componentId: "sc-xbv4af-2"
})(["cursor:", ";font-weight:", ";&:hover{font-weight:", ";}"], ({
  onClick
}) => onClick ? 'pointer' : 'default', ({
  selected
}) => selected ? '600' : 'initial', ({
  onClick
}) => onClick ? '600' : 'default');
const BrandItem = props => {
  const {
    brand,
    icon,
    onClick,
    selected
  } = props;
  const {
    name,
    logo
  } = brand !== null && brand !== void 0 ? brand : {};
  return jsxs(BrandItemContainer, {
    onClick: onClick,
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    width: "100%",
    selected: selected,
    children: [jsxs(FlexBox, {
      alignItems: "center",
      gap: 16,
      children: [typeof (logo === null || logo === void 0 ? void 0 : logo.url) === 'string' ? jsx(Logo, {
        src: logo.url
      }) : jsx(LogoPlaceholder, {
        children: icon
      }), jsx(Typography, {
        style: {
          wordBreak: 'break-word'
        },
        children: name
      })]
    }), selected && jsx(IconCheckmark, {})]
  });
};

const BrandSwitcher = () => {
  const {
    t
  } = useTranslation('hr-home-routes');
  const {
    setQuery,
    query
  } = useSearchQuery();
  const {
    user
  } = useUsersMeCached();
  const [open, setOpen] = useState(false);
  const [selectedBrandId, setSelectedBrandId] = useState(query.brand_id ? Number(query.brand_id) : undefined);
  const allBrands = useMemo(() => {
    return [{
      id: undefined,
      name: t('All brands'),
      logo: undefined
    }, ...user.company.brands];
  }, [user, t]);
  const selectedBrand = allBrands.find(brand => brand.id === selectedBrandId);
  const brandListWithoutSelectedBrand = useMemo(() => {
    return allBrands.filter(brand => brand.id !== selectedBrandId);
  }, [allBrands, selectedBrandId]);
  return jsxs(Box, {
    children: [jsx(Typography, {
      onClick: () => {
        setOpen(true);
      },
      children: t('Switch brand')
    }), jsx(Modal$1, {
      open: open,
      onCancel: () => setOpen(false),
      title: jsx(Typography, {
        fontWeight: "semibold",
        fontSize: "16px",
        children: t('Switch brand')
      }),
      hideFooter: true,
      width: 480,
      children: jsxs(Box, {
        width: "100%",
        children: [jsx(BrandItem, {
          brand: selectedBrand,
          icon: jsx(IconShop, {}),
          selected: true
        }), jsx(Card.Divider, {
          my: "20px"
        }), jsx(FlexBox, {
          flexDirection: "column",
          gap: "12px",
          children: brandListWithoutSelectedBrand.map((brand, index) => jsx(Box, {
            children: jsx(BrandItem, {
              brand: brand,
              icon: jsx(IconShop, {}),
              onClick: () => {
                setSelectedBrandId(brand.id);
                setQuery({
                  brand_id: brand.id
                });
              }
            })
          }, index))
        })]
      })
    })]
  });
};

const ApplicantsPageTitle = () => {
  const isMfe = false;
  const {
    t
  } = useTranslation('app-global-components');
  const isArchivedEntryInApplicantsPage = useFeatureIsOn('archived-entry-in-applicants-page');
  const location = useLocation();
  const menuItems = [{
    label: t('Applicants'),
    index: 'applicants',
    path: '/applicants/all-applicants',
    selected: location => location.pathname === '/hr/applicants' || location.pathname === '/hr/applicants/all-applicants'
  }, {
    label: t('Archived applicants'),
    index: 'inactive-applicants',
    path: '/applicants/inactive-applicants'
  }];
  const selectedKeys = getSelectedIndexesFromLocation({
    menuItems,
    location,
    isMfe,
    windowLocation: window.location
  });
  if (isArchivedEntryInApplicantsPage) {
    return jsx(Typography, {
      variant: "h1",
      ellipsis: 1,
      children: location.pathname.includes('inactive-applicants') ? t('Archived Applicants') : t('Applicants')
    });
  }
  return jsx(Dropdown, {
    menu: {
      variant: 'select',
      $width: 240,
      style: {
        marginTop: '6px'
      },
      items: menuItems,
      selectedKeys,
      renderLabel: (label, item) => {
        const pathObjOrNull = getPathFromItem(item, {
          isMfe
        });
        {
          return jsx("a", {
            href: pathObjOrNull === null || pathObjOrNull === void 0 ? void 0 : pathObjOrNull.fullUrl,
            children: label
          });
        }
      }
    },
    trigger: ['click'],
    children: jsxs(FlexBox, {
      gap: 8,
      alignItems: "center",
      children: [jsx(Typography, {
        variant: "h1",
        ellipsis: 1,
        children: selectedKeys[0] === 'inactive-applicants' ? t('Archived Applicants') : t('Applicants')
      }), jsx(ChevronDown, {})]
    })
  });
};

const upsellBadge = jsx(IconCrown, {
  color: "gold400"
});
const collapsedUpsellBadge = jsx(IconCrown, {
  color: "gold400",
  size: 16
});
const payrollStandaloneMapper = {
  hr: 'https://payroll.workstream.us',
  'hr-staging': 'https://payroll.staging.workstream.us/',
  'hr-staging-4': 'https://payroll.dev.workstream.us/',
  'hr-trunk': 'https://payroll-trunk.staging.workstream.us/',
  localhost: 'https://payroll.dev.workstream.us/'
};
const timeSchedulingStandaloneMapper = {
  hr: 'https://hub.workstream.us',
  'hr-staging': 'https://hub.staging.workstream.us',
  'hr-staging-4': 'https://hub.dev.workstream.us',
  'hr-trunk': 'https://hub.trunk.workstream.us',
  localhost: 'https://hub.dev.workstream.us'
};
// TODO: auto detect deploy env like this in ws-env
function getPayrollStandaloneUrl() {
  if (window.location.hostname.endsWith('vercel.app')) {
    return 'https://payroll.dev.workstream.us/';
  }
  const subLevelDomain = window.location.hostname.split('.')[0];
  return payrollStandaloneMapper[subLevelDomain] || 'https://payroll.workstream.us';
}
function getTimeSchedulingStandaloneUrl() {
  if (window.location.hostname.endsWith('vercel.app')) {
    return 'https://hub.dev.workstream.us';
  }
  const subLevelDomain = window.location.hostname.split('.')[0];
  return timeSchedulingStandaloneMapper[subLevelDomain] || 'https://hub.workstream.us';
}
const getTeamMenuItems = (options = {}) => {
  const {
    t = identity,
    hasNoChickfilaBrand
  } = options;
  return addParentToMenuItems([{
    index: 'dashboard',
    name: 'Home',
    label: t('Home'),
    icon: jsx(IconHome, {}),
    featureFlag: 'homepage-redesign-v1',
    hideWhenConditionMatch: true
  }, {
    index: 'new-dashboard',
    name: 'New Home',
    path: '/new-home',
    label: t('Home'),
    icon: jsx(IconHome, {}),
    featureFlag: 'homepage-redesign-v1',
    hideTopNavigation: true
  }, {
    index: 'messages',
    name: 'Messages',
    label: t('Messages'),
    icon: jsx(IconEnvelope, {}),
    userPermission: 'edit_message',
    upsellOnLite: {
      badge: upsellBadge,
      collapsedBadge: collapsedUpsellBadge,
      functionModule: 'messaging'
    }
  }, {
    index: 'schedule',
    name: 'Scheduling',
    label: t('Scheduling'),
    icon: jsx(IconCalendarNew, {}),
    upsellOnLite: {
      badge: upsellBadge,
      collapsedBadge: collapsedUpsellBadge,
      functionModule: 'scheduling'
    }
  }, {
    index: 'analytics',
    name: 'Reporting',
    label: t('Reporting'),
    icon: jsx(IconAnalysis, {}),
    upsellOnLite: {
      badge: upsellBadge,
      collapsedBadge: collapsedUpsellBadge,
      functionModule: 'data_analytics',
      path: '/analytics'
    },
    children: [{
      index: 'reports',
      path: '/analytics/reports',
      label: t('Custom'),
      name: 'Analytics Reports',
      pageTitle: t('Reports'),
      functionModule: 'data_analytics',
      featureFlag: 'embedded-analytics',
      userPermission: 'edit_custom_reports',
      renderWsLayoutMenuItem: /* istanbul ignore next */(element, item, middleVariables) => {
        const {
          featureFlags,
          originalElement,
          userPermissions
        } = middleVariables;
        return !featureFlags['embedded-analytics'] && userPermissions.edit_custom_reports && originalElement;
      }
    }, {
      index: 'sourcing',
      name: 'Sourcing Analytics',
      path: '/analytics/sourcing',
      label: t('Sourcing'),
      functionModule: 'data_analytics',
      featureFlag: ['embedded-analytics', 'location-based-hpt-and-jpt'],
      userPermission: 'is_super_admin',
      renderWsLayoutMenuItem: /* istanbul ignore next */(element, item, middleVariables) => {
        const {
          featureFlags,
          originalElement,
          userPermissions
        } = middleVariables;
        const isSuperAdmin = userPermissions.is_super_admin;
        return !featureFlags['embedded-analytics'] && (featureFlags['location-based-hpt-and-jpt'] && isSuperAdmin || !featureFlags['location-based-hpt-and-jpt']) && originalElement;
      }
    }, {
      index: 'workstream-iq',
      name: 'Workstream IQ',
      path: '/analytics/workstream-iq',
      label: t('Workstream IQ'),
      functionModule: ['data_analytics', 'workstream_iq'],
      featureFlag: ['embedded-analytics'],
      renderWsLayoutMenuItem: /* istanbul ignore next */(element, item, middleVariables) => {
        const {
          featureFlags,
          originalElement,
          functionModules
        } = middleVariables;
        return !featureFlags['embedded-analytics'] && functionModules.workstream_iq && originalElement;
      }
    }, {
      index: 'embedded_dashboard',
      name: 'Embedded Analytics Dashboard',
      path: '/analytics/embedded/dashboard',
      label: t('Dashboards'),
      functionModule: 'data_analytics',
      featureFlag: 'embedded-analytics'
    }, {
      index: 'embedded_reports',
      name: 'Embedded Analytics Reports',
      path: '/analytics/embedded/reports',
      label: t('Reports'),
      featureFlag: 'embedded-analytics',
      functionModule: 'data_analytics',
      userPermission: 'edit_custom_reports'
    }, {
      index: 'embedded_iq',
      name: 'Embedded Workstream IQ',
      path: '/analytics/embedded/workstream-iq',
      label: t('Workstream IQ'),
      featureFlag: ['embedded-analytics'],
      functionModule: ['data_analytics', 'workstream_iq']
    }]
  }, {
    index: 'hiring',
    name: 'Hiring',
    label: t('Hiring'),
    type: 'group',
    children: [{
      index: 'applicants',
      name: 'Applicants',
      label: t('Applicants'),
      icon: jsx(IconUserEntity, {}),
      pageTitle: jsx(ApplicantsPageTitle, {}),
      subRouteMenuItems: [{
        path: '/applicant'
      }, {
        path: '/applicants/inactive-applicants'
      }]
    }, {
      index: 'sourcing-tools',
      name: 'Sourcing Tools',
      label: t('Sourcing Tools'),
      icon: jsx(IconSpeaker, {})
    }, {
      index: 'job-postings',
      name: 'Job Postings',
      label: t('Job Postings'),
      icon: jsx(IconDocumentAdd, {})
    }, {
      index: 'talent-network',
      name: 'Talent Network',
      subApp: 'talent-network',
      path: '/landing',
      pageTitle: jsx(TalentNetworkPageTitle, {}),
      label: jsx(FlexBox, {
        alignItems: "center",
        gap: 6,
        children: jsx("span", {
          children: t('Talent Network')
        })
      }),
      functionModule: 'prospect_management',
      featureFlag: 'talent_network',
      icon: jsx(IconSourcingTools, {}),
      selected: () => isSubAppRoute(window.location.pathname, 'talent-network') && !window.location.hash.includes('settings'),
      upsellOnLite: {
        path: '/hiring-paywall',
        pageTitle: t('Talent Network'),
        badge: upsellBadge,
        collapsedBadge: collapsedUpsellBadge,
        functionModule: 'application_tracking'
      }
    }]
  }, {
    index: 'team-management',
    name: 'Team Management',
    label: t('Team Management'),
    type: 'group',
    children: [{
      index: 'onboarding-submenu',
      name: 'Onboarding',
      label: t('Onboarding'),
      icon: jsx(IconUserCheck, {}),
      featureFlag: 'hris-jobs',
      userPermission: 'manage_onboarding',
      functionModule: 'onboarding',
      children: [{
        label: t('Overview'),
        name: 'Onboarding Overview',
        index: 'onboarding-overview',
        path: '/onboarding/overview',
        userPermission: 'onboard_employee',
        subRouteMenuItems: [{
          path: '/onboarding/processes'
        }]
      }, {
        label: t('E-Verify'),
        name: 'E-Verify',
        path: '/onboarding/everify-cases',
        index: 'onboarding-e-verify',
        userPermission: 'onboard_employee',
        featureFlag: ['formi9_dot_com'],
        hideWhenConditionMatch: true
      }, {
        label: t('Onboarding Documents'),
        name: 'Onboarding Documents',
        path: '/onboarding/documents',
        index: 'onboarding-documents'
      }, {
        label: t('Activity log'),
        name: 'Onboarding Activity Log',
        path: '/onboarding/employees',
        index: 'onboarding-activity-log',
        userPermission: 'onboard_employee'
      }],
      renderWsLayoutMenuItem: /* istanbul ignore next */(element, item, middleVariables) => {
        const {
          functionModules,
          userPermissions,
          featureFlags,
          originalElement
        } = middleVariables;
        const showItem = !featureFlags['hris-jobs'] && functionModules.onboarding && userPermissions.manage_onboarding;
        if (!showItem) {
          return null;
        }
        return originalElement;
      }
    }, {
      index: 'onboarding-paywall',
      name: 'Onboarding Paywall',
      label: t('Onboarding'),
      path: '/onboarding',
      icon: jsx(IconUserCheck, {}),
      functionModule: 'onboarding',
      hideWhenConditionMatch: true,
      badge: upsellBadge,
      collapsedBadge: collapsedUpsellBadge,
      renderWsLayoutMenuItem: /* istanbul ignore next */(element, item, middleVariables) => {
        if (!(middleVariables === null || middleVariables === void 0 ? void 0 : middleVariables.functionModules.onboarding)) {
          return element;
        }
        if (middleVariables.userPermissions.manage_onboarding) {
          // Above submenu covers this case
          return null;
        }
        // Render nothing when no permission
        return null;
      },
      exact: true
    }, {
      index: 'team',
      name: 'Team',
      subApp: 'er',
      path: '/list',
      label: t('Team'),
      functionModule: 'team_records',
      selected: () => isSubAppRoute(window.location.pathname, 'er'),
      icon: jsx(IconUsers, {})
    }, {
      label: t('E-Verify'),
      name: 'E-Verify',
      path: '/onboarding/everify-cases',
      index: 'onboarding-e-verify',
      icon: jsx(IconUserCheck, {}),
      functionModule: 'onboarding',
      userPermission: ['manage_onboarding', 'onboard_employee'],
      featureFlag: ['hris-jobs', 'formi9_dot_com'],
      renderWsLayoutMenuItem: /* istanbul ignore next */(element, item, middleVariables) => {
        const {
          functionModules,
          userPermissions,
          featureFlags,
          originalElement
        } = middleVariables;
        const showItem = featureFlags['hris-jobs'] && !featureFlags['formi9_dot_com'] && functionModules.onboarding && userPermissions.manage_onboarding && userPermissions.onboard_employee;
        if (!showItem) {
          return null;
        }
        return originalElement;
      }
    }, {
      index: 'team-paywall',
      name: 'Team Paywall',
      subApp: 'er',
      path: '/list',
      label: t('Team'),
      functionModule: 'team_records',
      hideWhenConditionMatch: true,
      badge: upsellBadge,
      collapsedBadge: collapsedUpsellBadge,
      selected: () => isSubAppRoute(window.location.pathname, 'er'),
      icon: jsx(IconUsers, {})
    }, {
      index: 'documents',
      name: 'Adhoc Documents',
      subApp: 'doc',
      path: '/list',
      label: t('Documents'),
      functionModule: 'adhoc_documents',
      selected: () => isSubAppRoute(window.location.pathname, 'doc'),
      icon: jsx(IconCopy, {})
    }, {
      index: 'documents-paywall',
      name: 'Adhoc Documents Paywall',
      subApp: 'doc',
      path: '/list',
      label: t('Documents'),
      functionModule: 'adhoc_documents',
      hideWhenConditionMatch: true,
      badge: upsellBadge,
      collapsedBadge: collapsedUpsellBadge,
      selected: () => isSubAppRoute(window.location.pathname, 'doc'),
      icon: jsx(IconCopy, {})
    }, {
      index: 'surveys',
      name: 'Worker Surveys',
      subApp: 'survey',
      path: '/list',
      label: t('Surveys'),
      functionModule: 'worker_survey',
      selected: () => isSubAppRoute(window.location.pathname, 'survey'),
      icon: jsx(IconDocumentApprove, {})
    }, {
      index: 'surveys-paywall',
      name: 'Worker Surveys Paywall',
      subApp: 'survey',
      path: '/list',
      label: t('Surveys'),
      functionModule: 'worker_survey',
      hideWhenConditionMatch: true,
      badge: upsellBadge,
      collapsedBadge: collapsedUpsellBadge,
      selected: () => isSubAppRoute(window.location.pathname, 'survey'),
      icon: jsx(IconDocumentApprove, {})
    }]
  }, {
    index: 'payroll-group',
    name: 'Payroll',
    label: t('Payroll'),
    type: 'group',
    hideIfNoChildrenRendered: true,
    featureFlag: 'hris-jobs',
    children: [{
      index: 'payrolls',
      name: 'Payroll',
      href: '/payroll/payrolls',
      subApp: 'payroll',
      featureFlag: 'hris-jobs',
      label: t('Payroll'),
      icon: jsx(IconDollarCircle, {}),
      functionModule: 'payroll',
      userPermission: USER_PERMISSIONS.MANAGE_PAYROLL_OPERATIONS,
      selected: () => isSubAppRoute(window.location.pathname, 'payroll') && window.location.pathname.includes('payroll/payrolls')
    }, {
      index: 'payroll-reports',
      name: 'Payroll Reports',
      href: '/payroll/reports',
      subApp: 'payroll',
      featureFlag: 'hris-jobs',
      label: t('Reports'),
      icon: jsx(IconAnalysis, {}),
      functionModule: 'payroll',
      userPermission: USER_PERMISSIONS.MANAGE_PAYROLL_OPERATIONS,
      selected: () => isSubAppRoute(window.location.pathname, 'payroll') && window.location.pathname.includes('payroll/reports')
    }, {
      index: 'payroll-paywall',
      name: 'Payroll Paywall',
      label: t('Payroll'),
      icon: jsx(IconDollarCircle, {}),
      functionModule: 'payroll',
      hideWhenConditionMatch: true,
      badge: upsellBadge,
      renderWsLayoutMenuItem: /* istanbul ignore next */(element, item, middleVariables) => hasNoChickfilaBrand && !middleVariables.functionModules.payroll && element
    }]
  }, {
    index: 'payroll-group-legacy',
    name: 'Payroll',
    label: t('Payroll'),
    type: 'group',
    hideIfNoChildrenRendered: true,
    hideWhenConditionMatch: true,
    featureFlag: 'hris-jobs',
    children: [{
      index: 'payroll',
      name: 'Payroll',
      label: t('Payroll'),
      href: getPayrollStandaloneUrl(),
      hrefProps: {
        target: '_blank'
      },
      icon: jsx(IconDollarCircle, {}),
      functionModule: 'payroll',
      userPermission: USER_PERMISSIONS.MANAGE_PAYROLL_OPERATIONS,
      badge: jsx(IconExternalLink, {
        size: 20
      }),
      collapsedBadge: false
    }, {
      index: 'payroll-paywall',
      name: 'Payroll Paywall',
      label: t('Payroll'),
      icon: jsx(IconDollarCircle, {}),
      functionModule: 'payroll',
      hideWhenConditionMatch: true,
      badge: upsellBadge,
      renderWsLayoutMenuItem: /* istanbul ignore next */(element, item, middleVariables) => hasNoChickfilaBrand && !middleVariables.functionModules.payroll ? element : null
    }]
  }, {
    index: 'time-management',
    name: 'Time Management',
    label: t('TIME MANAGEMENT'),
    type: 'group',
    hideIfNoChildrenRendered: true,
    children: [{
      index: 'time-scheduling',
      name: 'Time and Scheduling',
      label: t('Time and Scheduling'),
      href: getTimeSchedulingStandaloneUrl(),
      hrefProps: {
        target: '_blank'
      },
      icon: jsx(IconClock, {}),
      functionModule: 'time_shift',
      badge: jsx(IconExternalLink, {
        size: 20
      }),
      collapsedBadge: false
    }]
  }, {
    index: 'account-settings',
    name: 'Account Settings',
    label: t('Account Settings'),
    type: 'group',
    hideWhenConditionMatch: true,
    children: [{
      index: 'my-profile',
      name: 'My Profile',
      label: t('My Profile'),
      icon: jsx(IconUser, {})
    }]
  }]);
};
const getAdminMenuItems = (options = {}) => {
  const {
    t = identity
  } = options;
  return addParentToMenuItems([{
    index: 'admin-home',
    name: 'Admin Home',
    path: '/company/dashboard',
    label: t('Home'),
    icon: jsx(IconHome, {}),
    subRouteMenuItems: [{
      path: '/company',
      params: {
        currentPanel: /brands\/\w+/
      }
    }]
  }, {
    // TODO: refactor company page to use new routes
    index: 'company-settings',
    name: 'Company Settings',
    label: t('Company Settings'),
    type: 'group',
    children: [{
      index: 'locations',
      name: 'Locations',
      label: t('Locations'),
      icon: jsx(IconLocationPin, {}),
      path: '/company',
      userPermission: 'edit_location',
      params: {
        currentPanel: 'location'
      }
    }, {
      index: 'tax-entities',
      name: 'Tax Entities',
      label: t('Tax Entities'),
      icon: jsx(IconTaxEntity, {}),
      path: '/company',
      userPermission: 'edit_location',
      params: {
        currentPanel: 'tax_entity'
      },
      upsellOnLite: {
        badge: upsellBadge,
        collapsedBadge: collapsedUpsellBadge,
        functionModule: 'onboarding'
      }
    }, {
      index: 'departments',
      name: 'Departments',
      label: t('Departments'),
      icon: jsx(IconDepartmentsNew, {}),
      path: '/company',
      userPermission: 'edit_location',
      params: {
        currentPanel: 'department'
      }
    }, {
      index: 'hris-jobs',
      name: 'HRIS Jobs',
      label: t('Jobs'),
      icon: jsx(IconBag, {}),
      path: '/hris/jobs',
      href: '/hris/jobs',
      featureFlag: 'hris-jobs',
      userPermission: 'edit_user',
      subApp: 'hris',
      selected: location => {
        return /^\/hris\/jobs/.test(window.location.pathname);
      }
    }, {
      index: 'integrations',
      name: 'Integrations',
      label: t('Integrations'),
      icon: jsx(IconPuzzle, {}),
      path: '/company',
      userPermission: 'edit_integration',
      params: {
        currentPanel: 'integrations'
      },
      upsellOnLite: {
        badge: upsellBadge,
        collapsedBadge: collapsedUpsellBadge,
        functionModule: 'application_tracking'
      }
    }, {
      index: 'custom-fields',
      name: 'Custom Fields',
      label: t('Custom Fields'),
      icon: jsx(IconBrush, {}),
      path: '/company',
      featureFlag: 'custom_field',
      params: {
        currentPanel: 'customFields'
      },
      userPermission: 'edit_custom_field',
      upsellOnLite: {
        badge: upsellBadge,
        collapsedBadge: collapsedUpsellBadge,
        functionModule: 'application_tracking'
      }
    }, {
      index: 'data-exports',
      name: 'Data Exports',
      label: t('Data Exports'),
      icon: jsx(IconDocumentExport, {}),
      path: '/company',
      featureFlag: 'data_export_tool',
      params: {
        currentPanel: 'dataExports'
      },
      userPermission: ['edit_data_export_template', 'edit_data_export_report'],
      renderWsLayoutMenuItem(element, item, middleVariables) {
        const {
          originalElement,
          featureFlags,
          userPermissions
        } = middleVariables;
        if (!featureFlags.data_export_tool) {
          return null;
        }
        if (!userPermissions.edit_data_export_template && !userPermissions.edit_data_export_report) {
          return null;
        }
        return originalElement;
      },
      upsellOnLite: {
        badge: upsellBadge,
        collapsedBadge: collapsedUpsellBadge,
        functionModule: 'application_tracking'
      }
    }, {
      index: 'applicants-assistant',
      label: t('AI Settings'),
      icon: jsx(IconAiStar, {}),
      path: '/company',
      functionModule: ['ai_assistant', 'voice_ai'],
      featureFlag: ['company_customize_ai_assistant_info'],
      userPermission: 'edit_company',
      params: {
        currentPanel: 'ai_assistant'
      },
      renderWsLayoutMenuItem: /* istanbul ignore next */(element, item, middleVariables) => {
        const {
          userPermissions,
          featureFlags,
          functionModules,
          originalElement
        } = middleVariables;
        const showItem = (functionModules.ai_assistant && featureFlags['company_customize_ai_assistant_info'] || functionModules.voice_ai) && userPermissions.edit_company;
        return showItem ? originalElement : null;
      }
    }, {
      label: t('Knowledge'),
      name: 'Knowledge Base',
      index: 'knowledge-base',
      subApp: 'knowledge-base',
      icon: jsx(OutlinedBookOpen, {}),
      featureFlag: ['ai-knowledge-base'],
      path: '/knowledge',
      selected: () => isSubAppRoute(window.location.pathname, 'knowledge-base')
    }]
  }, {
    label: t('Account settings'),
    name: 'Account settings',
    index: 'account-sub-routes-placeholder',
    path: '/account',
    type: 'group',
    featureFlag: 'test-only_account-sub-routes',
    children: [{
      label: t('Scheduling settings'),
      name: 'Scheduling settings',
      index: 'scheduling-settings',
      icon: jsx(IconClock, {}),
      path: '/account/scheduling'
    }, {
      label: t('Notification settings'),
      name: 'Notification settings',
      index: 'notification-settings',
      icon: jsx(IconBell, {}),
      path: '/account/notification'
    }, {
      label: t('E-verify quiz settings'),
      name: 'E-verify quiz settings',
      index: 'e-verify-quiz-settings',
      icon: jsx(IconCheckmark, {}),
      path: '/account/e-verify-quiz'
    }]
  }, {
    index: 'sourcing',
    name: 'Sourcing Admin',
    label: t('Sourcing'),
    type: 'group',
    functionModule: ['prospect_management'],
    featureFlag: ['enable-talent-network-v1.5'],
    children: [{
      index: 'talent-network',
      name: 'Talent Network',
      subApp: 'talent-network',
      label: t('Talent Network'),
      icon: jsx(IconSourcingTools, {}),
      path: '/settings/passive-prospects',
      functionModule: 'prospect_management',
      // userPermission: 'edit_talent_network_passive_prospects', // TODO: add this permission
      selected: () => {
        return isSubAppRoute(window.location.pathname, 'talent-network') && /\/settings\/passive-prospects/.test(window.location.hash);
      },
      featureFlag: 'enable-talent-network-v1.5',
      upsellOnLite: {
        badge: upsellBadge,
        collapsedBadge: collapsedUpsellBadge,
        functionModule: 'application_tracking'
      }
    }]
  }, {
    index: 'hiring',
    name: 'Hiring Admin',
    label: t('Hiring'),
    type: 'group',
    children: [{
      index: 'position-templates',
      name: 'Position Templates',
      label: t('Position Templates'),
      icon: jsx(IconPositionNew2, {}),
      path: '/company',
      userPermission: 'edit_position_template',
      params: {
        currentPanel: 'position'
      },
      subRouteMenuItems: [{
        path: '/job-posting-template',
        params: {}
      }]
    }, {
      index: 'hiring-process-templates',
      name: 'Hiring Processes',
      label: t('Hiring Processes'),
      icon: jsx(IconPlusSync, {}),
      path: '/company',
      userPermission: 'edit_hiring_process_template',
      params: {
        currentPanel: 'hiring_process_template'
      },
      subRouteMenuItems: [{
        path: '/edit-hiring-process-template',
        params: {}
      }, {
        path: '/create-hiring-process-template',
        params: {}
      }]
    }, {
      index: 'rating-plans',
      name: 'Evaluation Plan',
      label: t('Evaluation Plan'),
      icon: jsx(IconClipboard, {}),
      path: '/company',
      userPermission: 'edit_evaluation',
      params: {
        currentPanel: 'ratingPlans'
      },
      upsellOnLite: {
        badge: upsellBadge,
        collapsedBadge: collapsedUpsellBadge,
        functionModule: 'application_tracking'
      }
    }, {
      index: 'reapplications',
      name: 'Reapplications',
      label: t('Reapplications'),
      icon: jsx(IconReapply, {}),
      path: '/company',
      userPermission: 'edit_evaluation',
      params: {
        currentPanel: 'reapplications'
      },
      upsellOnLite: {
        badge: upsellBadge,
        collapsedBadge: collapsedUpsellBadge,
        functionModule: 'application_tracking'
      }
    }]
  }, {
    index: 'team-management',
    name: 'Team Management Admin',
    label: t('Team Management'),
    userPermission: 'manage_onboarding',
    type: 'group',
    children: [{
      index: 'admin-onboarding',
      name: 'Onboarding',
      label: t('Onboarding'),
      icon: jsx(IconUserCheck, {}),
      functionModule: 'onboarding',
      // TODO: support function for userPermission to support complex check in the future
      userPermission: 'edit_onboarding_process',
      children: [{
        index: 'admin-onboarding-processes',
        name: 'Onboarding Processes',
        label: t('Onboarding Processes'),
        path: '/admin/onboarding/processes',
        userPermission: 'edit_onboarding_process'
      }, {
        label: t('Onboarding Documents'),
        path: '/admin/onboarding/documents',
        index: 'admin-onboarding-documents',
        userPermission: 'manage_onboarding',
        featureFlag: 'hris-jobs',
        renderWsLayoutMenuItem: /* istanbul ignore next */(element, item, middleVariables) => {
          const {
            userPermissions,
            featureFlags,
            originalElement
          } = middleVariables;
          const showItem = featureFlags['hris-jobs'] && userPermissions.manage_onboarding;
          if (!showItem) {
            return null;
          }
          return originalElement;
        }
      }]
    }, {
      index: 'admin-onboarding-paywall',
      name: 'Onboarding Paywall',
      label: t('Onboarding'),
      path: '/admin/onboarding',
      icon: jsx(IconUserCheck, {}),
      functionModule: 'onboarding',
      hideWhenConditionMatch: true,
      badge: upsellBadge,
      collapsedBadge: collapsedUpsellBadge
    }]
  }, {
    index: 'time-management',
    name: 'Time Management Admin',
    label: t('Time Management'),
    type: 'group',
    hideIfNoChildrenRendered: true,
    children: [{
      index: 'time-off-policies',
      name: 'Time Off Policies',
      label: t('Time Off Policies'),
      icon: jsx(IconClock, {}),
      href: '/time-off/policies',
      subApp: 'time-off',
      functionModule: 'time_off',
      selected: location => {
        return /^\/time-off\/policies/.test(window.location.pathname);
      }
    }]
  }, {
    index: 'payroll',
    name: 'Payroll Admin',
    label: t('Payroll'),
    functionModule: 'payroll',
    type: 'group',
    hideIfNoChildrenRendered: true,
    children: [{
      index: 'payroll-entities',
      name: 'Payroll Entities',
      label: t('Payroll Entities'),
      icon: jsx(IconTaxEntity, {}),
      href: '/payroll/entities',
      featureFlag: 'payroll-integration',
      userPermission: USER_PERMISSIONS.CONFIGURE_PAYROLL,
      functionModule: 'payroll',
      subApp: 'payroll',
      selected: location => {
        return /^\/payroll\/entities/.test(window.location.pathname);
      }
    }]
  }, {
    index: 'benefit',
    name: 'Benefits Admin',
    label: t('Benefits'),
    functionModule: 'benefit',
    type: 'group',
    hideIfNoChildrenRendered: true,
    children: [{
      index: 'benefit-entities',
      name: 'Benefits',
      label: t('Benefits'),
      icon: jsx(IconHealth, {}),
      href: '/benefit',
      userPermission: USER_PERMISSIONS.BENEFITS_ADMINISTRATION,
      functionModule: 'benefit',
      selected: () => {
        return /^\/benefit/.test(window.location.pathname);
      }
    }]
  }, {
    index: 'access-control',
    name: 'Access Control',
    label: t('Access control'),
    type: 'group',
    children: [{
      index: 'users',
      name: 'Users',
      label: t('Users'),
      icon: jsx(IconProfile, {}),
      path: '/company',
      userPermission: 'edit_user',
      params: {
        currentPanel: 'manageUsers'
      }
    }, {
      index: 'role-management',
      name: 'Roles and Permissions',
      label: t('Roles and Permissions'),
      icon: jsx(IconLock, {}),
      path: '/company',
      userPermission: 'edit_user',
      params: {
        currentPanel: 'role_management'
      }
    }]
  }]);
};
const getProfileMenuItems = (options = {}) => {
  const {
    t = identity,
    userName,
    showSwitchBrand,
    onLogout
  } = options;
  return addParentToMenuItems(compact([{
    label: userName,
    name: 'Company name',
    index: 'company-name',
    renderItem: /* istanbul ignore next */() => jsx(Typography, {
      variant: "body",
      fontWeight: "bold",
      py: "10px",
      px: 12,
      children: userName
    }),
    disabled: true
  }, {
    type: 'divider',
    name: 'Profile divider',
    index: 'profile-divider'
  }, {
    label: t('My profile'),
    name: 'My profile',
    index: 'my-profile'
  }, {
    label: t('Account settings'),
    name: 'Account settings',
    index: 'account',
    path: '/account?currentPanel=scheduling',
    // All 3 routes below under /account are using same page title `Account settings`
    selected: location => /^\/account?/.test(location.pathname)
  }, {
    label: t('Referral'),
    name: 'Referral',
    index: 'referral'
  }, showSwitchBrand && {
    label: t('Switch brand'),
    name: 'Switch brand',
    index: 'switch-brand',
    renderLabel: /* istanbul ignore next */() => jsx(BrandSwitcher, {})
  }, {
    label: t('Switch account'),
    name: 'Switch account',
    index: 'switch-account',
    renderLabel: /* istanbul ignore next */() => jsx(AccountSwitchLabel, {})
  }, {
    type: 'divider',
    name: 'Divider',
    index: 'divider'
  }, {
    label: t('Log out'),
    name: 'Log out',
    index: 'log-out',
    onClick: onLogout
  }]));
};
const getHelpMenuItems = (options = {}) => {
  const {
    t = identity,
    isBentoOn
  } = options;
  return addParentToMenuItems([{
    label: t('Help with account setup'),
    name: 'Help with account setup',
    index: 'setup',
    href: 'https://workstream.my.site.com/knowledgebase/s/contactsupport',
    hrefProps: {
      target: '_blank'
    },
    renderItem: /* istanbul ignore next */item => isBentoOn ? item : null
  }, {
    type: 'divider',
    name: 'Divider below setup',
    index: 'divider-below-setup',
    renderItem: /* istanbul ignore next */item => isBentoOn ? item : null
  }, {
    label: t('Help center'),
    name: 'Help center',
    href: 'https://workstream.my.site.com/knowledgebase/s',
    hrefProps: {
      target: '_blank'
    },
    index: 'help-center'
  }, {
    label: t('Contact us'),
    name: 'Contact us',
    index: 'contact-us',
    onClick: /* istanbul ignore next */() => {
      show();
    }
  }, {
    label: t('Tips and tricks'),
    name: 'Tips and tricks',
    href: 'https://workstream.my.site.com/knowledgebase/s/topic/0TO5b000000wsaNGAQ/best-practices-tips',
    hrefProps: {
      target: '_blank'
    },
    index: 'tips-and-tricks'
  }, {
    label: t('Blog'),
    name: 'Blog',
    href: 'https://www.workstream.us/blog',
    hrefProps: {
      target: '_blank'
    },
    index: 'blog'
  }]);
};

function useAppLayout(props) {
  var _a, _b, _c, _d;
  const {
    isMfe,
    routerType = 'hash'
  } = props;
  const location = useLocation();
  const wsGrowthbook = useWsGrowthbook();
  const navigate = getNavigateFn();
  const isAdminViewOnlyVisibleToAdminUsers = useFeatureIsOn('admin-view-only-visible-to-admin-users');
  const [collapsed, setCollapsed] = useSessionStorageState('left-navigation-collapsed', {
    defaultValue: false
  });
  const isHomePageRedesignOn = useFeatureIsOn('homepage-redesign-v1');
  const [urlState, setUrlState] = useUrlState();
  const {
    user
  } = useUsersMeCached();
  const {
    data: brands
  } = useBrands((_a = user.company) === null || _a === void 0 ? void 0 : _a.nickname);
  const isHomepageRedesignV2Enabled = useFeatureIsOn('homepage-redesign-v2');
  const hasMultipleBrands = brands.length > 1;
  const showSwitchBrand = hasMultipleBrands && isHomepageRedesignV2Enabled;
  const isLiteTier = ((_b = user.company.tiers) === null || _b === void 0 ? void 0 : _b.length) === 1 && ((_c = user.company.tiers) === null || _c === void 0 ? void 0 : _c[0]) === 'lite';
  // The value must go from falsy to truthy, otherwise it will glitch(show menu item at first and then hide it)
  const hasNoChickfilaBrand = !!brands.length && brands.every(brand => brand.nickname !== 'chickfila');
  // TODO: refactor this as a hook in ws-biz-hooks lib when 3rd copy occurs
  const [isBentoOn, setIsBentoOn] = useState(true);
  useEffect(() => {
    document.addEventListener('bento-noGuideFound', () => setIsBentoOn(false));
    return () => {
      document.removeEventListener('bento-noGuideFound', () => setIsBentoOn(false));
    };
  }, []);
  const {
    analytics
  } = useSegmentAnalytics();
  const {
    data: rawAvailablePermissions
  } = useAvailablePermissions();
  const userHasPermission = useCallback(permissionKey => {
    var _a, _b;
    const {
      flattenAvailablePermissions
    } = parseAvailablePermissions(rawAvailablePermissions);
    if (permissionKey === 'is_super_admin') {
      return (user === null || user === void 0 ? void 0 : user.is_super_admin) || false;
    }
    return hasUserPermissionV2((_b = (_a = user === null || user === void 0 ? void 0 : user.company_admin) === null || _a === void 0 ? void 0 : _a.permissions) !== null && _b !== void 0 ? _b : [], flattenAvailablePermissions, permissionKey);
  }, [user, rawAvailablePermissions]);
  const onLogout = useCallback(() => __awaiter(this, void 0, void 0, function* () {
    try {
      shutdown();
      yield service.user.logout();
      message.success('Logout success');
      service.user.clientLogout();
    } catch (error) {
      message.error('Error while logging out');
    }
  }), []);
  const {
    t
  } = useTranslation('app-global-components');
  const teamMenuItems = useMemo(() => {
    const menuItems = getTeamMenuItems({
      t,
      isMfe,
      hasNoChickfilaBrand
    });
    if (isLiteTier) {
      return buildLiteMenuItems(menuItems);
    }
    return menuItems;
  }, [isMfe, hasNoChickfilaBrand, isLiteTier, t]);
  const adminMenuItems = useMemo(() => {
    const menuItems = getAdminMenuItems({
      t
    });
    if (isLiteTier) {
      return buildLiteMenuItems(menuItems);
    }
    return menuItems;
  }, [isLiteTier, t]);
  const profileMenuItems = useMemo(() => {
    var _a;
    return getProfileMenuItems({
      t,
      userName: (_a = user.company.name) !== null && _a !== void 0 ? _a : '',
      onLogout,
      showSwitchBrand
    });
  }, [onLogout, user.company.name, t, showSwitchBrand]);
  const helpMenuItems = useMemo(() => getHelpMenuItems({
    t,
    isBentoOn
  }), [isBentoOn, t]);
  const selectedKeysByMenuName = useMemo(() => {
    const sharedOptions = {
      isMfe,
      routerType,
      location,
      windowLocation: window.location
    };
    const selectedAdminMenuIndexes = getSelectedIndexesFromLocation(Object.assign(Object.assign({}, sharedOptions), {
      menuItems: adminMenuItems
    }));
    const selectedTeamMenuIndexes = getSelectedIndexesFromLocation(Object.assign(Object.assign({}, sharedOptions), {
      menuItems: teamMenuItems
    }));
    const selectedProfileMenuIndexes = getSelectedIndexesFromLocation(Object.assign(Object.assign({}, sharedOptions), {
      menuItems: profileMenuItems
    }));
    return {
      adminView: selectedAdminMenuIndexes,
      teamView: selectedTeamMenuIndexes,
      profile: selectedProfileMenuIndexes,
      all: [...selectedProfileMenuIndexes, ...selectedAdminMenuIndexes, ...selectedTeamMenuIndexes]
    };
  }, [isMfe, routerType, location, teamMenuItems, adminMenuItems, profileMenuItems]);
  const [openKeys, setOpenKeys] = useState(() => getDefaultOpenKeysFromSelectedIndexes([...adminMenuItems, ...teamMenuItems], selectedKeysByMenuName.all, {
    isMfe
  }));
  const variant = /^\/(company|admin)/.test(location.pathname) || selectedKeysByMenuName.adminView.length > 0 ? 'admin' : 'team';
  const getHomeUrlByVariant = useCallback(variant => {
    var _a, _b;
    const firstMenuItem = variant === 'team' ? isHomePageRedesignOn ? teamMenuItems[1] : teamMenuItems[0] : adminMenuItems[0];
    return (_b = (_a = getPathFromItem(firstMenuItem, {
      isMfe
    })) === null || _a === void 0 ? void 0 : _a.fullUrl) !== null && _b !== void 0 ? _b : '/';
  }, [isMfe, teamMenuItems, adminMenuItems, isHomePageRedesignOn]);
  const onVariantChange = useCallback(newVariant => {
    navigate(getHomeUrlByVariant(newVariant));
    analytics === null || analytics === void 0 ? void 0 : analytics.track(`global nav - switch to ${newVariant} view`, {
      from: window.location.href
    });
  }, [navigate, getHomeUrlByVariant, analytics]);
  const onCollapsedChange = useCallback(newCollapsed => {
    if (urlState['global-nav-collapsed'] !== undefined) {
      setUrlState(Object.assign(Object.assign({}, urlState), {
        'global-nav-collapsed': undefined
      }));
    }
    setCollapsed(newCollapsed);
    analytics === null || analytics === void 0 ? void 0 : analytics.track(`global nav - ${variant} side nav ${newCollapsed ? 'collapsed' : 'expanded'}`, {
      from: window.location.href
    });
  }, [analytics, setCollapsed, variant, urlState, setUrlState]);
  const selectedMenuItem = useMemo(() => {
    return getSelectedMenuItemsFromSelectedIndexes([...profileMenuItems, ...(variant === 'team' ? teamMenuItems : adminMenuItems)], selectedKeysByMenuName.all, {
      isMfe
    })[0];
  }, [isMfe, selectedKeysByMenuName.all, teamMenuItems, adminMenuItems, variant, profileMenuItems]);
  useEffect(() => {
    var _a;
    if (!selectedMenuItem) {
      return;
    }
    const rootParent = getRootParent(selectedMenuItem);
    const pageName = (_a = selectedMenuItem.name) !== null && _a !== void 0 ? _a : selectedMenuItem.index;
    analytics === null || analytics === void 0 ? void 0 : analytics.page(rootParent.name, pageName, {
      redirect_path: window.location.pathname
    });
  }, [analytics, selectedMenuItem]);
  const defaultBackToUrl = usePreviousUrl();
  const backToUrl = useMemo(() => {
    return getBackToUrl(selectedMenuItem, {
      isMfe,
      location,
      defaultUrl: defaultBackToUrl
    });
  }, [selectedMenuItem, location, isMfe, defaultBackToUrl]);
  return {
    user,
    wsGrowthbook,
    isBentoOn,
    userHasPermission,
    adminMenuItems,
    teamMenuItems,
    helpMenuItems,
    profileMenuItems,
    selectedKeysByMenuName,
    variant,
    getHomeUrlByVariant,
    onVariantChange,
    collapsed: urlState['global-nav-collapsed'] === 'true' || collapsed,
    onCollapsedChange,
    openKeys,
    setOpenKeys,
    selectedMenuItem,
    backToUrl,
    hideAdminView: isAdminViewOnlyVisibleToAdminUsers && ((_d = user === null || user === void 0 ? void 0 : user.company_role) === null || _d === void 0 ? void 0 : _d.role_type) !== 'Super Admin'
  };
}

var unreadIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2216px%22%20height%3D%2212px%22%20viewBox%3D%220%200%2016%2012%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EShape%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Notification%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Notifications-bar%22%20transform%3D%22translate%28-1389.000000%2C%20-179.000000%29%22%20fill%3D%22%23B5BFD5%22%20stroke%3D%22%23B5BFD5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1393.63608%2C180%20C1393.60324%2C180%201393.57222%2C180.001697%201393.53938%2C180.006789%20C1393.31315%2C180.035644%201393.11611%2C180.15955%201393.00299%2C180.342862%20L1390.0966%2C185.073345%20C1389.89591%2C185.399234%201390.01815%2C185.813384%201390.36845%2C186.000092%20C1390.71875%2C186.186799%201391.16392%2C186.073077%201391.36461%2C185.747188%20L1393.79481%2C181.788995%20L1402.75297%2C190.148387%20C1403.03759%2C190.413172%201403.49918%2C190.414869%201403.78562%2C190.150084%20C1404.07024%2C189.885299%201404.07206%2C189.455873%201403.78745%2C189.189391%20L1394.18707%2C180.230838%20L1394.15241%2C180.198589%20C1394.01375%2C180.069591%201393.82765%2C180%201393.63608%2C180%20L1393.63608%2C180%20Z%22%20id%3D%22Shape%22%20transform%3D%22translate%281397.000000%2C%20185.173913%29%20scale%281%2C%20-1%29%20translate%28-1397.000000%2C%20-185.173913%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var readIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2216px%22%20height%3D%2212px%22%20viewBox%3D%220%200%2016%2012%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EShape%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Notification%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Notifications-bar%22%20transform%3D%22translate%28-1389.000000%2C%20-416.000000%29%22%20fill%3D%22%2365CC95%22%20stroke%3D%22%2365CC95%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1393.63608%2C417%20C1393.60324%2C417%201393.57222%2C417.001697%201393.53938%2C417.006789%20C1393.31315%2C417.035644%201393.11611%2C417.15955%201393.00299%2C417.342862%20L1390.0966%2C422.073345%20C1389.89591%2C422.399234%201390.01815%2C422.813384%201390.36845%2C423.000092%20C1390.71875%2C423.186799%201391.16392%2C423.073077%201391.36461%2C422.747188%20L1393.79481%2C418.788995%20L1402.75297%2C427.148387%20C1403.03759%2C427.413172%201403.49918%2C427.414869%201403.78562%2C427.150084%20C1404.07024%2C426.885299%201404.07206%2C426.455873%201403.78745%2C426.189391%20L1394.18707%2C417.230838%20L1394.15241%2C417.198589%20C1394.01375%2C417.069591%201393.82765%2C417%201393.63608%2C417%20L1393.63608%2C417%20Z%22%20id%3D%22Shape%22%20transform%3D%22translate%281397.000000%2C%20422.173913%29%20scale%281%2C%20-1%29%20translate%28-1397.000000%2C%20-422.173913%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

// Need to exclude some lines from formatting b/c double quotes are required!
const CheckMark = /*#__PURE__*/styled.span.withConfig({
  displayName: "notification-item__CheckMark",
  componentId: "sc-dn0mop-0"
})(["width:16px;height:12px;display:inline-block;background:", ";opacity:", ";&:hover{background:url(\"", "\");opacity:1;}"], props => {
  return props.read ? `url("${readIcon}")` : `url("${unreadIcon}")`;
}, props => {
  return props.read ? 0 : 1;
}, readIcon);
function NotificationItem({
  notification,
  onClickToggleState,
  onClick
}) {
  let checkmarkTitle = 'Mark as read';
  if (notification.status !== 'unread') {
    checkmarkTitle = 'Mark as unread';
  }
  return jsxs("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '8px',
      marginLeft: '16px',
      marginRight: '16px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '8px',
      paddingBottom: '8px',
      borderRadius: '6px',
      backgroundColor: 'white',
      boxShadow: '0 2px 6px 0 rgba(0,0,0,0.05)',
      cursor: 'pointer'
    },
    onClick: onClick,
    children: [jsxs("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
      },
      children: [jsxs("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        },
        children: [jsx("div", {
          style: {
            width: '6px',
            height: '6px',
            background: '#FC5757',
            opacity: notification.status === 'unread' ? 1 : 0,
            borderRadius: '100%',
            marginRight: '16px',
            fontSize: '13px',
            flexShrink: 0
          }
        }), notification.subject]
      }), jsx("div", {
        onClick: onClickToggleState,
        style: {
          display: 'flex',
          marginTop: '5px'
        },
        children: jsx(Tooltip, {
          title: checkmarkTitle,
          children: jsx(CheckMark, {
            read: notification.status === 'read'
          })
        }, checkmarkTitle)
      })]
    }), jsx("div", {
      style: {
        display: 'flex',
        marginLeft: '22px',
        marginTop: '5px'
      },
      children: jsx(Tooltip, {
        title: dayjs(notification.created_at).format('MMMM D, YYYY h:mm A'),
        children: jsx(Typography, {
          variant: "body",
          color: "gray500",
          fontSize: 11,
          children: dayjs(notification.created_at).fromNow()
        })
      })
    })]
  });
}

const TabText = /*#__PURE__*/styled.div.withConfig({
  displayName: "notifications-filter__TabText",
  componentId: "sc-14dodx-0"
})(["display:flex;font-size:16px;font-weight:600;cursor:pointer;padding-bottom:4px;border-bottom:", ";color:", ";&:hover{border-bottom:2px solid #0d8ce6;color:#0d8ce6;}"], props => {
  if (props['selected']) {
    return '2px solid #0D8CE6';
  } else {
    return '2px solid transparent';
  }
}, props => {
  if (props['selected']) {
    return '#0D8CE6';
  } else {
    return '#A4A4A4';
  }
});
const NotificationsFilterContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "notifications-filter__NotificationsFilterContainer",
  componentId: "sc-14dodx-1"
})(["display:flex;align-items:center;& ", " ~ ", "{margin-left:16px;}"], TabText, TabText);
function NotificationsFilter({
  onFiltersChange,
  filters,
  totalUnreadCount
}) {
  const {
    t
  } = useTranslation('app-global-components');
  const {
    status
  } = filters;
  return jsxs(NotificationsFilterContainer, {
    children: [jsxs(TabText, {
      selected: status === 'unread',
      onClick: () => {
        onFiltersChange(Object.assign(Object.assign({}, filters), {
          status: 'unread'
        }));
      },
      children: [t('Unread'), totalUnreadCount !== 0 && ` (${totalUnreadCount})`]
    }), jsx(TabText, {
      selected: status === 'all',
      onClick: () => {
        onFiltersChange(Object.assign(Object.assign({}, filters), {
          status: 'all'
        }));
      },
      children: t('All')
    })]
  });
}

var markAllIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2024%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3Eic_done_all_black_24px%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Notification%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Notifications-bar%22%20transform%3D%22translate%28-1215.000000%2C%20-78.000000%29%22%20fill%3D%22%23A4AEC5%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22ic_done_all_black_24px%22%20transform%3D%22translate%281215.000000%2C%2078.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M18%2C2%20L16.59%2C0.59%20L10.25%2C6.93%20L11.66%2C8.34%20L18%2C2%20Z%20M22.24%2C0.59%20L11.66%2C11.17%20L7.48%2C7%20L6.07%2C8.41%20L11.66%2C14%20L23.66%2C2%20L22.24%2C0.59%20Z%20M0.41%2C8.41%20L6%2C14%20L7.41%2C12.59%20L1.83%2C7%20L0.41%2C8.41%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var markAllIconHighlighted = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2024%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3Eic_done_all_black_24px%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Notification%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Notifications-bar%22%20transform%3D%22translate%28-1215.000000%2C%20-99.000000%29%22%20fill%3D%22%2365CC95%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22ic_done_all_black_24px%22%20transform%3D%22translate%281215.000000%2C%2099.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M18%2C2%20L16.59%2C0.59%20L10.25%2C6.93%20L11.66%2C8.34%20L18%2C2%20Z%20M22.24%2C0.59%20L11.66%2C11.17%20L7.48%2C7%20L6.07%2C8.41%20L11.66%2C14%20L23.66%2C2%20L22.24%2C0.59%20Z%20M0.41%2C8.41%20L6%2C14%20L7.41%2C12.59%20L1.83%2C7%20L0.41%2C8.41%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var notificationSettingIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2219px%22%20height%3D%2219px%22%20viewBox%3D%220%200%2019%2019%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3Eset%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Notifications-bar%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20transform%3D%22translate%28-1342.000000%2C%20-76.000000%29%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22set%22%20transform%3D%22translate%281342.000000%2C%2076.000000%29%22%20fill%3D%22%23B5BFD5%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15.3188617%2C11.7950863%20L15.2011795%2C12.0267877%20L15.3485856%2C12.2414775%20L16.798065%2C14.3525747%20L16.8573719%2C13.7863805%20L14.2785802%2C16.2548332%20L14.8259421%2C16.1912824%20L12.4590581%2C14.8068911%20L12.2631602%2C14.6923104%20L12.052817%2C14.778758%20C11.9032845%2C14.8402133%2011.7510824%2C14.8963595%2011.5974579%2C14.9467301%20L11.3519736%2C15.0272198%20L11.2982425%2C15.275764%20L10.7802093%2C17.672029%20L11.2227342%2C17.3201219%20L7.57536737%2C17.3201219%20L8.01448717%2C17.6574862%20L7.38182502%2C15.1491492%20L7.32540033%2C14.9254403%20L7.10658722%2C14.8419509%20C6.97007424%2C14.7898635%206.83480189%2C14.7330457%206.70177092%2C14.6719185%20L6.47591179%2C14.5681371%20L6.26594049%2C14.7002128%20L4.04272018%2C16.0986575%20L4.60258358%2C16.154609%20L2.02379198%2C13.6862949%20L2.09130349%2C14.2401224%20L3.53747412%2C11.9748916%20L3.66541675%2C11.7744868%20L3.56743109%2C11.55842%20C3.49937077%2C11.4083411%203.43736398%2C11.2551138%203.38190541%2C11.0999842%20L3.29670204%2C10.8616519%20L3.04449027%2C10.8117133%20L0.541821608%2C10.316178%20L0.904761909%2C10.7515172%20L0.904761909%2C7.26056152%20L0.556016445%2C7.69285642%20L3.17695384%2C7.08730772%20L3.40386551%2C7.03488141%20L3.49206722%2C6.82304803%20C3.55571668%2C6.67018159%203.62597627%2C6.51931616%203.70222678%2C6.37176293%20L3.82151958%2C6.14091812%20L3.67570686%2C5.92524798%20L2.31351758%2C3.91044711%20L2.25488202%2C4.47163356%20L4.81841184%2C1.98002227%20L4.26594804%2C2.0443948%20L6.54411502%2C3.3975912%20L6.74068095%2C3.51434835%20L6.95267328%2C3.42741095%20C7.07546783%2C3.3770533%207.20020786%2C3.33022961%207.32604522%2C3.28725211%20L7.55759588%2C3.20817014%20L7.61652169%2C2.97454723%20L8.22784218%2C0.550848127%20L7.78872257%2C0.888211385%20L11.4357585%2C0.888211385%20L10.9932333%2C0.536302686%20L11.5284928%2C3.01229677%20L11.5800752%2C3.25090523%20L11.8128641%2C3.33618141%20C12.0019491%2C3.40544777%2012.187934%2C3.48335018%2012.3690683%2C3.56915703%20L12.5948485%2C3.67611346%20L12.8069182%2C3.54486865%20L14.9119318%2C2.24212641%20L14.3574669%2C2.18688067%20L16.9620051%2C4.64042869%20L16.8936608%2C4.08141358%20L15.4785101%2C6.26265967%20L15.348768%2C6.46263792%20L15.4458411%2C6.67973817%20C15.5126089%2C6.8290617%2015.5734198%2C6.98156979%2015.6277402%2C7.13588526%20L15.7091282%2C7.36709571%20L15.9516876%2C7.42313046%20L18.4439956%2C7.99888963%20L18.0952381%2C7.56659192%20L18.0952381%2C11.0575476%20L18.458169%2C10.6222103%20L15.8268296%2C11.1432794%20L15.5905832%2C11.190062%20L15.4983431%2C11.4086436%20C15.4434143%2C11.5388086%2015.3834488%2C11.6679221%2015.3188617%2C11.7950863%20Z%20M15.9162796%2C11.5786168%20L16.0057296%2C12.0139542%20L18.6370691%2C11.492885%20L19%2C11.4210158%20L19%2C11.0575476%20L19%2C7.56659192%20L19%2C7.21486226%20L18.6512425%2C7.13429425%20L16.1589345%2C6.55853504%20L16.0553111%2C6.99083275%20L16.482882%2C6.84578024%20C16.4205973%2C6.66883932%2016.350887%2C6.49401238%2016.2743019%2C6.32273293%20L15.8600715%2C6.50123557%20L16.241633%2C6.73981145%20L17.6567836%2C4.55856536%20L17.8559608%2C4.25156308%20L17.5884393%2C3.99955023%20L14.9839011%2C1.54600223%20L14.7286704%2C1.3055677%20L14.4294362%2C1.4907565%20L12.3244226%2C2.79349874%20L12.5656704%2C3.16918369%20L12.7622724%2C2.76921035%20C12.5560025%2C2.67149629%2012.3443572%2C2.58284567%2012.1291719%2C2.50401811%20L11.971018%2C2.92009976%20L12.4135431%2C2.82790276%20L11.8782836%2C0.351908681%20L11.8022081%2C0%20L11.4357585%2C0%20L7.78872257%2C0%20L7.43469486%2C0%20L7.34960299%2C0.337363258%20L6.73828255%2C2.76106238%20L7.17740211%2C2.86780481%20L7.02875903%2C2.4483575%20C6.88558337%2C2.49725657%206.74368139%2C2.55052234%206.60392571%2C2.60783571%20L6.77829949%2C3.01762333%20L7.01248399%2C2.63765548%20L4.73431697%2C1.28445908%20L4.43252058%2C1.10519661%20L4.18185321%2C1.34883162%20L1.61832339%2C3.84044293%20L1.35398056%2C4.09736978%20L1.55968785%2C4.40162937%20L2.92187711%2C6.41643024%20L3.29879199%2C6.17083909%20L2.89535719%2C5.96991525%20C2.80800024%2C6.13896067%202.72752144%2C6.31176938%202.65456947%2C6.4869776%20L3.07331834%2C6.6550128%20L2.96968286%2C6.2227179%20L0.348745464%2C6.8282666%20L0%2C6.90884173%20L0%2C7.26056152%20L0%2C10.7515172%20L0%2C11.1149933%20L0.362940301%2C11.1868564%20L2.86560896%2C11.6823917%20L2.95504963%2C11.2470525%20L2.52819385%2C11.3941209%20C2.59177169%2C11.5719618%202.66283902%2C11.747579%202.74088155%2C11.9196695%20L3.15415632%2C11.7390448%20L2.77083852%2C11.5031979%20L1.3246679%2C13.7684286%20L1.13080875%2C14.0720828%20L1.39217941%2C14.3222561%20L3.97097102%2C16.7905703%20L4.2282661%2C17.0368426%20L4.53083444%2C16.8465217%20L6.75405476%2C15.4480769%20L6.50999763%2C15.0741448%20L6.3182243%2C15.4763712%20C6.46956361%2C15.545911%206.62344013%2C15.6105431%206.77882317%2C15.6698304%20L6.94270521%2C15.2558906%20L6.50358537%2C15.362632%20L7.13624752%2C17.870969%20L7.22133883%2C18.2083333%20L7.57536737%2C18.2083333%20L11.2227342%2C18.2083333%20L11.5891824%2C18.2083333%20L11.665259%2C17.8564262%20L12.1832921%2C15.4601612%20L11.7407673%2C15.3679626%20L11.8840767%2C15.789195%20C12.0589186%2C15.7318676%2012.2320583%2C15.6679977%2012.4022062%2C15.5980698%20L12.2275116%2C15.1884139%20L11.9959651%2C15.5699367%20L14.3628491%2C16.9543279%20L14.6613946%2C17.1289473%20L14.910211%2C16.8907771%20L17.4890026%2C14.4223244%20L17.7593681%2C14.163527%20L17.5483094%2C13.8561302%20L16.09883%2C11.7450331%20L15.7237078%2C11.9932553%20L16.128554%2C12.1914243%20C16.2025146%2C12.0458051%2016.2712149%2C11.8978844%2016.3342162%2C11.74859%20L15.9162796%2C11.5786168%20Z%20M13.5714286%2C9.10416664%20C13.5714286%2C7.01934787%2011.8498568%2C5.32926827%209.72619049%2C5.32926827%20C7.60252411%2C5.32926827%205.8809524%2C7.01934787%205.8809524%2C9.10416664%20C5.8809524%2C11.1889855%207.60252411%2C12.879065%209.72619049%2C12.879065%20C10.2701101%2C12.879065%2010.7989358%2C12.7678657%2011.2859444%2C12.5554707%20C11.5142706%2C12.4558927%2011.6171375%2C12.1934598%2011.515704%2C11.9693104%20C11.4142705%2C11.7451609%2011.1469476%2C11.6441758%2010.9186214%2C11.7437537%20C10.5467062%2C11.905954%2010.1429527%2C11.9908537%209.72619049%2C11.9908537%20C8.10221034%2C11.9908537%206.78571427%2C10.6984398%206.78571427%2C9.10416664%20C6.78571427%2C7.50989344%208.10221034%2C6.21747966%209.72619049%2C6.21747966%20C11.3501706%2C6.21747966%2012.6666667%2C7.50989344%2012.6666667%2C9.10416664%20C12.6666667%2C9.31482138%2012.6437577%2C9.52225955%2012.5987772%2C9.72417302%20C12.5453991%2C9.96378271%2012.6999891%2C10.2005047%2012.9440635%2C10.2529064%20C13.1881381%2C10.3053081%2013.429271%2C10.153546%2013.4826491%2C9.91393629%20C13.5414937%2C9.64978799%2013.5714286%2C9.37873112%2013.5714286%2C9.10416664%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var relaxImage = "76f5092ffdbbf570.svg";

const LoadMoreNotificationButton = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "notification-center-modal__LoadMoreNotificationButton",
  componentId: "sc-1n3k99o-0"
})(["border:none;background:transparent !important;box-shadow:unset;font-size:12px;"]);
// Need to exclude some lines from formatting b/c double quotes are required!
const MarkAll = /*#__PURE__*/styled.div.withConfig({
  displayName: "notification-center-modal__MarkAll",
  componentId: "sc-1n3k99o-1"
})(["height:19px;margin-top:3px;padding-left:26px;background:url(\"", "\");background-repeat:no-repeat;&:hover{background:url(\"", "\");background-repeat:no-repeat;}"], markAllIcon, markAllIconHighlighted);
const NotificationSetting = /*#__PURE__*/styled.span.withConfig({
  displayName: "notification-center-modal__NotificationSetting",
  componentId: "sc-1n3k99o-2"
})(["height:19px;padding-left:23px;display:inline-block;background:url(\"", "\");background-repeat:no-repeat;&:hover{background:url(\"", "\");background-repeat:no-repeat;}"], notificationSettingIcon, notificationSettingIcon);
function NotificationCenterModal(props) {
  const {
    t
  } = useTranslation('app-global-components');
  const {
      visible,
      closeModal
    } = props,
    restProps = __rest(props, ["visible", "closeModal"]);
  const [notificationsList, setNotificationsList] = useState([]);
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  const [loadMoreParams, setLoadMoreParams] = useState({});
  const [status, setStatus] = useState('unread');
  const {
    isLoading: isFetchingNotificationsList,
    refetch
  } = useHrQuery({
    url: '/v1/notifications',
    method: 'get',
    params: Object.assign({
      status: status === 'all' ? undefined : status,
      per_page: 20
    }, loadMoreParams)
  }, {
    enabled: visible,
    refetchInterval: 2 * 60 * 1000,
    onSuccess(res) {
      var _a, _b;
      setNotificationsList(prev => {
        var _a, _b;
        return unionBy(prev, (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.notifications) !== null && _b !== void 0 ? _b : [], 'id');
      });
      setTotalUnreadCount((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.unread_count) !== null && _b !== void 0 ? _b : 0);
    }
  });
  const {
    mutateAsync: markAllAsRead,
    isLoading: isMarkingAllAsRead
  } = useHrMutation({
    url: '/v1/notifications/read_all'
  });
  function handleClickNotificationItem(notification) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      const {
        id
      } = notification;
      const {
        data: {
          notification: notificationDetail
        }
      } = yield hrAxios({
        url: '/v1/notifications/{id}',
        urlParams: {
          id
        }
      });
      closeModal();
      const {
        notification_type: type,
        position_application_id: applicantId
      } = notificationDetail;
      // This is just a daily email notification not tied to a position application
      if (type === 'hr_next_day_schedule') {
        getNavigateFn()('/schedule');
        return;
      }
      if (type === 'new_applicant') {
        getNavigateFn()(`/applicant/${applicantId}?section=info`);
      } else if (type === 'applicant_form_submission') {
        getNavigateFn()(`/applicant/${applicantId}?section=form&digestkey=${(_a = notificationDetail === null || notificationDetail === void 0 ? void 0 : notificationDetail.form_submission) === null || _a === void 0 ? void 0 : _a['digest_key']}`);
      } else if (type === 'applicant_online_quiz') {
        getNavigateFn()(`/applicant/${applicantId}?section=quiz&digestkey=${(_b = notificationDetail === null || notificationDetail === void 0 ? void 0 : notificationDetail.application_online_quiz) === null || _b === void 0 ? void 0 : _b['digest_key']}`);
      } else if (type === 'applicant_replies_sms') {
        getNavigateFn()(`/applicant/${applicantId}?section=history`);
      } else if (type === 'applicant_replies_email') {
        getNavigateFn()(`/applicant/${applicantId}?section=history`);
      } else if (type === 'hr_mention') {
        getNavigateFn()(`/applicant/${applicantId}?section=notes`);
      } else if (['applicant_scheduling_stage', 'meeting'].includes(type)) {
        getNavigateFn()('/schedule');
      } else {
        console.warn(`Unhandled notification type: '${type}'`);
      }
    });
  }
  function handleMarkAllAsRead() {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        yield markAllAsRead({});
        if (status === 'unread') {
          setNotificationsList([]);
        } else {
          setNotificationsList(prev => prev.map(item => Object.assign(Object.assign({}, item), {
            status: 'read'
          })));
        }
        refetch();
        message.success('Marked all as read');
      } catch (error) {
        message.error('Failed to mark all as read');
      }
    });
  }
  function handleClickNotificationSetting() {
    closeModal();
    getNavigateFn()('/account?currentPanel=notification');
  }
  function handleClickLoadMore() {
    setLoadMoreParams(prev => {
      var _a, _b;
      return Object.assign(Object.assign({}, prev), {
        first_notification_id: (_a = notificationsList[0]) === null || _a === void 0 ? void 0 : _a.id,
        last_notification_id: (_b = notificationsList[notificationsList.length - 1]) === null || _b === void 0 ? void 0 : _b.id
      });
    });
  }
  function handleToggleNotificationState(notification) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        status,
        id
      } = notification;
      try {
        if (status === 'read') {
          yield hrAxios({
            url: '/v1/notifications/{id}/unread',
            method: 'get',
            urlParams: {
              id
            }
          });
          setNotificationsList(prev => prev.map(item => item.id === id ? Object.assign(Object.assign({}, item), {
            status: 'unread'
          }) : item));
        } else if (status === 'unread') {
          yield hrAxios({
            url: '/v1/notifications/{id}/read',
            method: 'get',
            urlParams: {
              id
            }
          });
          setNotificationsList(prev => prev.map(item => item.id === id ? Object.assign(Object.assign({}, item), {
            status: 'read'
          }) : item));
        }
      } catch (error) {
        message.error('Failed to toggle notification state');
      }
    });
  }
  function handleFiltersChange(filters) {
    const {
      status
    } = filters;
    setNotificationsList([]);
    setLoadMoreParams({});
    setStatus(status);
  }
  function renderEmptyUnreadView() {
    return jsx("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 1
      },
      children: jsxs("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        },
        children: [jsx("div", {
          style: {
            display: 'flex'
          },
          children: jsx("img", {
            src: relaxImage,
            style: {
              display: 'block',
              opacity: 1
            },
            alt: t('Relax'),
            role: "presentation"
          })
        }), jsx("div", {
          style: {
            display: 'flex',
            marginTop: '8px'
          },
          children: jsx(Typography, {
            variant: "body",
            color: "gray500",
            fontSize: 16,
            children: t('Relax. Everything is done!')
          })
        }), jsx("div", {
          style: {
            display: 'flex',
            justifyContent: 'center',
            height: 0,
            marginTop: '8px',
            marginBottom: '8px'
          },
          children: jsx(Spin, {
            spinning: isFetchingNotificationsList
          })
        })]
      })
    });
  }
  function renderNotificationsList() {
    if (status === 'unread' && totalUnreadCount === 0) {
      return renderEmptyUnreadView();
    }
    const todayList = notificationsList.filter(item => {
      const isToday = dayjs(item.created_at).isSame(dayjs(), 'day');
      if (isToday) {
        return true;
      }
      return false;
    });
    const notTodayList = notificationsList.filter(item => {
      const isToday = dayjs(item.created_at).isSame(dayjs(), 'day');
      if (!isToday) {
        return true;
      }
      return false;
    });
    const todayItems = todayList.map(notification => {
      return jsx(NotificationItem, {
        notification: notification,
        onClickToggleState: event => {
          event.stopPropagation();
          handleToggleNotificationState(notification);
        },
        onClick: () => {
          handleClickNotificationItem(notification);
        }
      }, notification.id);
    });
    const notTodayItems = notTodayList.map(notification => {
      return jsx(NotificationItem, {
        notification: notification,
        onClickToggleState: event => {
          event.stopPropagation();
          handleToggleNotificationState(notification);
        },
        onClick: () => {
          handleClickNotificationItem(notification);
        }
      }, notification.id);
    });
    let todaySection = null;
    let notTodaySection = null;
    if (todayItems.length > 0) {
      todaySection = jsxs("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        },
        children: [jsx("div", {
          style: {
            display: 'flex',
            borderBottom: '1px solid #E6EAEE',
            background: 'white',
            padding: '5px 18px',
            marginBottom: '12px'
          },
          children: jsx(Typography, {
            variant: "body",
            color: "gray500",
            fontSize: 12,
            children: t('Today')
          })
        }), todayItems]
      });
    }
    if (notTodayItems.length > 0) {
      notTodaySection = jsxs("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        },
        children: [jsx("div", {
          style: {
            display: 'flex',
            borderBottom: '1px solid #E6EAEE',
            background: 'white',
            padding: '5px 18px',
            marginBottom: '12px'
          },
          children: jsx(Typography, {
            variant: "body",
            color: "gray500",
            fontSize: 12,
            children: t('Earlier')
          })
        }), notTodayItems]
      });
    }
    return jsx("div", {
      style: {
        display: 'flex',
        flexDirection: 'column'
      },
      children: jsxs("div", {
        style: {
          overflow: 'auto'
        },
        children: [jsx("div", {
          style: {
            display: 'flex',
            justifyContent: 'center'
          },
          children: jsx(Spin, {
            spinning: isFetchingNotificationsList,
            style: {
              margin: '8px'
            }
          })
        }), todaySection, notTodaySection, renderLoadingMoreSection()]
      })
    });
  }
  function renderLoadingMoreSection() {
    return jsx("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '16px',
        marginBottom: '16px'
      },
      children: jsx(LoadMoreNotificationButton, {
        onClick: handleClickLoadMore,
        loading: isFetchingNotificationsList,
        children: t('Load more notification')
      })
    });
  }
  return jsx(Drawer, Object.assign({
    visible: visible,
    title: jsx(Typography, {
      variant: "h3",
      children: t('Notifications')
    }),
    variant: "secondary",
    onClose: closeModal,
    bodyStyle: {
      padding: 'unset',
      backgroundColor: '#F5F6FA'
    }
  }, restProps, {
    children: jsx(Spin, {
      spinning: isMarkingAllAsRead,
      tip: "loading",
      children: jsxs("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        },
        children: [jsxs("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            padding: '16px',
            borderBottom: '1px solid #E6EAEE',
            flexShrink: 0
          },
          children: [jsx(NotificationsFilter, {
            filters: {
              status
            },
            onFiltersChange: handleFiltersChange,
            totalUnreadCount: totalUnreadCount
          }), jsx("div", {
            style: {
              display: 'flex',
              flexGrow: 1
            }
          }), jsxs("div", {
            style: {
              display: 'flex',
              alignItems: 'center'
            },
            children: [jsx("div", {
              style: {
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                marginRight: '8px'
              },
              onClick: handleClickNotificationSetting,
              children: jsx("div", {
                style: {
                  display: 'flex',
                  marginRight: '5px'
                },
                children: jsx(NotificationSetting, {
                  children: jsx(Typography, {
                    variant: "body",
                    color: "gray500",
                    fontSize: 12,
                    children: t('Settings')
                  })
                })
              })
            }), jsx("div", {
              style: {
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer'
              },
              onClick: handleMarkAllAsRead,
              children: jsx("div", {
                style: {
                  display: 'flex',
                  marginRight: '5px'
                },
                children: jsx(Tooltip, {
                  title: t('Mark all as read'),
                  placement: "bottom",
                  children: jsx(MarkAll, {})
                })
              })
            })]
          })]
        }), renderNotificationsList()]
      })
    })
  }));
}

const NotificationsButton = () => {
  const [open, setOpen] = useState(false);
  return jsxs(Fragment, {
    children: [jsx(Notifications, {
      onClick: () => setOpen(!open)
    }), open && jsx(NotificationCenterModal, {
      visible: open,
      closeModal: () => setOpen(false)
    })]
  });
};

// copied from HR repo, might be useful in the future
// const Intercome_tracking_allow_list = {
//   betas: ['defined_roles_v1'],
//   function_modules: [],
// }
// function getIntercomFunctionModulesAttribute (functionModuleArray: string[]) {
//   return _.intersection(functionModuleArray, Intercome_tracking_allow_list.function_modules).join(',')
// }
const INTERCOM_APP_ID_PRODUCTION = 'lmaakz1h';
const INTERCOM_APP_ID_DEV = 'r6we9b43';
// mono projects use `NX_DEPLOY_ENV`, but hr project uses `DEPLOY_ENV`
const deployEnv = (() => {
  return process.env.DEPLOY_ENV || process.env.NX_DEPLOY_ENV || 'production';
})();
const appId = deployEnv === 'production' ? INTERCOM_APP_ID_PRODUCTION : INTERCOM_APP_ID_DEV;
function useInitIntercom(user) {
  useEffect(() => {
    var _a, _b, _c, _d, _e;
    const sandbox = user.company.source === 'from_sandbox_v1';
    Intercom({
      app_id: appId,
      name: user.name,
      // Full name
      email: user.email,
      // Email address
      user_id: String(user.id),
      'Company name': user.company.nickname,
      role: user.company_admin.role,
      created_at: user.created_at ? new Date(user.created_at).getTime() : undefined,
      company: {
        id: user.company.id,
        company_id: user.company.id,
        name: user.company.name,
        company_slug: user.company.nickname,
        trial: user.company.trial,
        platform: user.company.platform,
        sandbox,
        tiers: (_a = user.company.tiers) === null || _a === void 0 ? void 0 : _a.join(','),
        // function_modules: getIntercomFunctionModulesAttribute(user.company.function_modules || []),
        function_modules: '',
        ae_name: (_b = user.company.customer_salesforce_attributes) === null || _b === void 0 ? void 0 : _b.ae_name,
        csm_name: (_c = user.company.customer_salesforce_attributes) === null || _c === void 0 ? void 0 : _c.csm_name,
        primary_brand: (_d = user.company.customer_salesforce_attributes) === null || _d === void 0 ? void 0 : _d.primary_active_brand_name,
        sales_segmentation: (_e = user.company.customer_salesforce_attributes) === null || _e === void 0 ? void 0 : _e.sales_segmentation
      }
    });
  }, [user]);
}

function AppLayout(props) {
  var _a, _b;
  const {
      children,
      isMfe = true,
      routerType = 'hash',
      showNavMenu: propShowNavMenu = true,
      loadingPlaceholder
    } = props,
    restProps = __rest(props, ["children", "isMfe", "routerType", "showNavMenu", "loadingPlaceholder"]);
  const {
    t
  } = useTranslation('app-global-components');
  const {
    user,
    wsGrowthbook,
    variant,
    getHomeUrlByVariant,
    onVariantChange,
    collapsed,
    onCollapsedChange,
    userHasPermission,
    adminMenuItems,
    teamMenuItems,
    profileMenuItems,
    helpMenuItems,
    selectedKeysByMenuName,
    selectedMenuItem,
    openKeys,
    setOpenKeys,
    backToUrl,
    hideAdminView
  } = useAppLayout(props);
  useInitIntercom(user);
  const isFullScreenRoute = useIsFullScreenRoute();
  const showNavMenu = propShowNavMenu && !isFullScreenRoute;
  return jsx(WsLayout, Object.assign({
    variant: variant,
    showLoadingPage: true,
    collapsed: collapsed,
    onVariantChange: onVariantChange,
    user: user,
    adminMenuItems: adminMenuItems,
    teamMenuItems: teamMenuItems,
    helpMenuItems: helpMenuItems,
    profileMenuItems: profileMenuItems,
    isFeatureFlagOn: flag => {
      var _a, _b;
      return (_b = (_a = wsGrowthbook.instance) === null || _a === void 0 ? void 0 : _a.isOn(flag)) !== null && _b !== void 0 ? _b : false;
    },
    companyHasFunctionModule: module => {
      var _a, _b;
      return (_b = (_a = user.company) === null || _a === void 0 ? void 0 : _a.function_modules) === null || _b === void 0 ? void 0 : _b.includes(module);
    },
    userHasPermission: userHasPermission,
    menuItemRenderLabel: (label, item) => {
      var _a;
      const pathObjOrNull = getPathFromItem(item, {
        isMfe,
        routerType
      });
      if (!pathObjOrNull) {
        if (item.href) {
          return jsx("a", Object.assign({
            href: item.href,
            rel: "noreferrer"
          }, (_a = item.hrefProps) !== null && _a !== void 0 ? _a : {}, {
            children: label
          }));
        }
        return label;
      }
      return jsx("a", {
        href: pathObjOrNull.fullUrl,
        children: label
      });
    },
    notificationsButton: jsx(NotificationsButton, {}),
    leftNavigation: showNavMenu && undefined,
    topNavigation: showNavMenu && !(selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.hideTopNavigation) && undefined,
    leftNavigationProps: {
      headerLogoBannerProps: {
        homeAnchorProps: {
          href: getHomeUrlByVariant(variant)
        }
      },
      onCollapsedChange: onCollapsedChange,
      mainMenuProps: {
        selectedKeys: selectedKeysByMenuName.all,
        openKeys: openKeys,
        onOpenChange: setOpenKeys,
        omitPropKeys
      },
      footerLabel: t(`Switch to ${variant === 'team' ? 'admin' : 'team'} view`)
    },
    topNavigationProps: {
      title: (_b = (_a = selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.pageTitle) !== null && _a !== void 0 ? _a : selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.label) !== null && _b !== void 0 ? _b : '',
      backToUrl
    },
    loadingPageProps: {
      message: t('Switching your experience...')
    },
    // hide admin view until growthbook is ready to avoid flash of admin view
    hideAdminView: (wsGrowthbook === null || wsGrowthbook === void 0 ? void 0 : wsGrowthbook.ready) ? hideAdminView : true
  }, restProps, {
    children: (wsGrowthbook === null || wsGrowthbook === void 0 ? void 0 : wsGrowthbook.ready) || !loadingPlaceholder ? jsx(S$1.Content, {
      children: children
    }) : loadingPlaceholder
  }));
}

dayjs.extend(dayjsRelativeTimePlugin);

export { AccountSwitcher, AppLayout, CatchAllErrorBoundary, ChunkLoadErrorFallback, ErrorPage, GeneralErrorFallback, Loader, NotFoundPage, NotificationCenterModal, WsThemeProvider, getAdminMenuItems, getHelpMenuItems, getPayrollStandaloneUrl, getProfileMenuItems, getTeamMenuItems, getTimeSchedulingStandaloneUrl, shouldForwardProp };
